"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9447],{

/***/ 76609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": () => (/* reexport safe */ _lib_contexts__WEBPACK_IMPORTED_MODULE_0__.U)
/* harmony export */ });
/* harmony import */ var _lib_contexts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40752);
/* harmony import */ var _lib_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65071);



/***/ }),

/***/ 40752:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": () => (/* reexport */ PlanTypeProvider),
  "U": () => (/* reexport */ usePlanType)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/contexts/PlanTypeContext.tsx


const PlanTypeContext = /*#__PURE__*/(0,react.createContext)(undefined);
const PlanTypeProvider = ({
  children
}) => {
  const {
    0: type,
    1: setType
  } = (0,react.useState)(undefined);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PlanTypeContext.Provider, {
    value: {
      type,
      setType
    },
    children: children
  });
};
const usePlanType = () => {
  const context = (0,react.useContext)(PlanTypeContext);

  if (!context) {
    throw new Error("usePlanType must be used within a PlanTypeProvider");
  }

  return context;
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/contexts/index.ts


/***/ }),

/***/ 99234:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "withError": () => (/* reexport */ withError),
  "withGIInsuranceHeader": () => (/* reexport */ withGIInsuranceHeader),
  "withMMTInsuranceHeader": () => (/* reexport */ withMMTInsuranceHeader),
  "withMyPartnerInsuranceHeader": () => (/* reexport */ withMyPartnerInsuranceHeader),
  "withPartnerInsuranceHeader": () => (/* reexport */ withPartnerInsuranceHeader)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/ErrorScreen/index.tsx
var ErrorScreen = __webpack_require__(81175);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withError.tsx


function withError(component, error, pageName, statusCode) {
  return error ? /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorScreen/* ErrorScreen */.C, {
    error: error,
    pageName: pageName,
    trackError: true,
    statusCode: statusCode,
    "data-test-id": "ErrorScreen"
  }) : component;
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/LoadAdobeScript/index.tsx
var LoadAdobeScript = __webpack_require__(38474);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/GIInsuranceHeader/index.tsx
var GIInsuranceHeader = __webpack_require__(22274);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withGIInsuranceHeader.tsx

const _excluded = ["Wrapper", "forceLogin"];





function withGIInsuranceHeader(component, headerOptions = {}, mobileTitle = "", myOrders = false, goToMyOrders = () => void 0, displayWhiteHeader = false, showPwaHeaderBackButton = true, onLoginSuccess = () => void 0) {
  const {
    Wrapper,
    forceLogin = false
  } = headerOptions,
        headerProps = (0,objectWithoutProperties/* default */.Z)(headerOptions, _excluded);

  const giHeaderWithAuth = /*#__PURE__*/(0,jsx_runtime.jsx)(GIInsuranceHeader/* GIInsuranceHeader */.c, {
    headerProps: headerProps,
    mobileTitle: mobileTitle,
    forceLogin: forceLogin,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader,
    showPwaHeaderBackButton: showPwaHeaderBackButton,
    onLoginSuccess: onLoginSuccess,
    "data-test-id": "giHeaderWithAuth-GIInsuranceHeader"
  });

  if (forceLogin) {
    return giHeaderWithAuth;
  }

  if (Wrapper) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      "data-test-id": "Wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LoadAdobeScript/* default */.Z, {
        partner: "gi",
        "data-test-id": "LoadAdobeScript"
      }), giHeaderWithAuth, component]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LoadAdobeScript/* default */.Z, {
      partner: "gi",
      "data-test-id": "LoadAdobeScript"
    }), giHeaderWithAuth, component]
  });
}
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/MMTInsuranceHeader/index.tsx
var MMTInsuranceHeader = __webpack_require__(809);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withMMTInsuranceHeader.tsx

const withMMTInsuranceHeader_excluded = ["Wrapper"];





function withMMTInsuranceHeader(component, headerOptions = {}, mobileTitle = "", myOrders = false, goToMyOrders = () => void 0, displayWhiteHeader = false, isMyBiz = false, exitWebViewOnBack = false, showPwaHeaderBackButton = true, showPwaHeader = true) {
  const {
    Wrapper
  } = headerOptions,
        headerProps = (0,objectWithoutProperties/* default */.Z)(headerOptions, withMMTInsuranceHeader_excluded);

  const authComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(MMTInsuranceHeader/* MMTInsuranceHeader */.X, {
    headerProps: headerProps,
    mobileTitle: mobileTitle,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader,
    isMyBiz: isMyBiz,
    exitWebViewOnBack: exitWebViewOnBack,
    showPwaHeaderBackButton: showPwaHeaderBackButton,
    showPwaHeader: showPwaHeader,
    "data-test-id": "authComponent-MMTInsuranceHeader"
  });

  if (headerProps?.forceLogin) {
    return authComponent;
  }

  if (Wrapper) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      "data-test-id": "Wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LoadAdobeScript/* default */.Z, {
        "data-test-id": "LoadAdobeScript"
      }), authComponent, component]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LoadAdobeScript/* default */.Z, {
      "data-test-id": "LoadAdobeScript"
    }), authComponent, component]
  });
}
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/MyPartnerInsuranceHeader/index.tsx
var MyPartnerInsuranceHeader = __webpack_require__(88410);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withMyPartnerInsuranceHeader.tsx

const withMyPartnerInsuranceHeader_excluded = ["Wrapper"];





function withMyPartnerInsuranceHeader(component, headerOptions = {}, mobileTitle = "", myOrders = false, goToMyOrders = () => void 0, displayWhiteHeader = false, isMyBiz = false, exitWebViewOnBack = false) {
  const {
    Wrapper
  } = headerOptions,
        headerProps = (0,objectWithoutProperties/* default */.Z)(headerOptions, withMyPartnerInsuranceHeader_excluded);

  const authComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(MyPartnerInsuranceHeader/* MyPartnerInsuranceHeader */.h, {
    headerProps: headerProps,
    mobileTitle: mobileTitle,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader,
    isMyBiz: isMyBiz,
    exitWebViewOnBack: exitWebViewOnBack,
    "data-test-id": "authComponent-MyPartnerInsuranceHeader"
  });

  if (headerProps?.forceLogin && true) {
    window.location.href = "https://mypartner.makemytrip.com/";
  }

  if (Wrapper) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      "data-test-id": "Wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LoadAdobeScript/* default */.Z, {
        "data-test-id": "LoadAdobeScript"
      }), authComponent, component]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LoadAdobeScript/* default */.Z, {
      "data-test-id": "LoadAdobeScript"
    }), authComponent, component]
  });
}
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withPartnerInsuranceHeader.tsx




 // import { MyPartnerInsuranceHeader } from "../static/components/MyPartnerInsuranceHeader";




function withPartnerInsuranceHeader(component) {
  let headerComponent = null;
  const {
    0: partnerHeader,
    1: setPartnerHeader
  } = (0,react.useState)("");
  (0,react.useEffect)(() => {
    const partner = (0,utils/* getPartnerOnClientSide */.et)();
    setPartnerHeader(partner);
  }, []);

  if (partnerHeader === src.PARTNER.MMT) {
    headerComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(MMTInsuranceHeader/* MMTInsuranceHeader */.X, {
      "data-test-id": "MMTInsuranceHeader"
    });
  } else if (partnerHeader === src.PARTNER.GI) {
    headerComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(GIInsuranceHeader/* GIInsuranceHeader */.c, {
      "data-test-id": "GIInsuranceHeader"
    }); // } else if (partnerHeader === PARTNER.MYPARTNER) {
    //   headerComponent = <MyPartnerInsuranceHeader />;
  }

  if (headerComponent) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [headerComponent, component]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: component
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/index.ts






/***/ }),

/***/ 89565:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": () => (/* reexport */ useIntersectionObserver)
});

// UNUSED EXPORTS: useBreakpoint

// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useBreakpoint/index.tsx
var useBreakpoint = __webpack_require__(53293);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useIntersectionObserver/index.tsx

const useIntersectionObserver = (callback, options = {}) => {
  const {
    root = null,
    rootMargin = "0px",
    threshold = 0,
    triggerOnce = false,
    triggerOnLeaveViewport = false
  } = options;
  const {
    0: isIntersecting,
    1: setIsIntersecting
  } = (0,react.useState)(false);
  const {
    0: entry,
    1: setEntry
  } = (0,react.useState)(null);
  const {
    0: hasTriggered,
    1: setHasTriggered
  } = (0,react.useState)(false);
  const observerRef = (0,react.useRef)(null);
  const elementRef = (0,react.useRef)(null);
  const previousIntersectingRef = (0,react.useRef)(false);
  const ref = (0,react.useCallback)(node => {
    // Disconnect previous observer if it exists
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    } // Store the element reference


    elementRef.current = node;

    if (!node) {
      setIsIntersecting(false);
      setEntry(null);
      previousIntersectingRef.current = false;
      return;
    } // Skip if triggerOnce is true and already triggered


    if (triggerOnce && hasTriggered) {
      return;
    } // Create new observer


    observerRef.current = new IntersectionObserver(entries => {
      const [observerEntry] = entries;
      const isCurrentlyIntersecting = observerEntry.isIntersecting;
      setIsIntersecting(isCurrentlyIntersecting);
      setEntry(observerEntry); // Call the callback with formatted data

      if (callback) {
        const previousIntersecting = previousIntersectingRef.current;
        let shouldTriggerCallback = false;

        if (triggerOnLeaveViewport) {
          // Trigger only when transitioning from not intersecting to intersecting
          shouldTriggerCallback = !previousIntersecting && isCurrentlyIntersecting;
        } else {
          // Normal behavior - trigger on any intersection change
          shouldTriggerCallback = true;
        } // Update previous intersecting state BEFORE calling callback to prevent multiple calls


        previousIntersectingRef.current = isCurrentlyIntersecting;

        if (shouldTriggerCallback) {
          const data = {
            isIntersecting: isCurrentlyIntersecting,
            intersectionRatio: observerEntry.intersectionRatio,
            boundingClientRect: observerEntry.boundingClientRect,
            intersectionRect: observerEntry.intersectionRect,
            rootBounds: observerEntry.rootBounds,
            target: observerEntry.target,
            time: observerEntry.time
          };
          callback(data);
        }
      } else {
        // Update previous intersecting state even if no callback
        previousIntersectingRef.current = isCurrentlyIntersecting;
      } // Mark as triggered if triggerOnce is enabled and element is intersecting


      if (triggerOnce && isCurrentlyIntersecting) {
        setHasTriggered(true);
      }
    }, {
      root,
      rootMargin,
      threshold
    }); // Start observing

    observerRef.current.observe(node);
  }, [callback, root, rootMargin, threshold, triggerOnce, triggerOnLeaveViewport, hasTriggered]); // Cleanup on unmount

  (0,react.useEffect)(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);
  return {
    ref,
    isIntersecting,
    entry
  };
};
/* harmony default export */ const hooks_useIntersectionObserver = ((/* unused pure expression or super */ null && (useIntersectionObserver)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/index.ts



/***/ }),

/***/ 53293:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ useBreakpoint)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
 // export const useBreakpoint = () => {
//     const [windowSize, setWindowSize] = useState<number>(1200);
//     function handleResize() {
//         console.log('IN THE FUNCTION: ', window.innerWidth);
//         // Set window width/height to state
//         setWindowSize(window.innerWidth);
//     }
//     useEffect(() => {
//         window.addEventListener('resize', handleResize);
//         handleResize();
//         return () => window.removeEventListener('resize', handleResize);
//     }, []); // Empty array ensures that effect is only run on mount
//     return windowSize;
// };

const useBreakpoint = () => {
  const {
    0: breakpoint,
    1: setBreakpoint
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("lg");
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const handleResize = () => {
      if (window.matchMedia("(max-width: 768px)").matches) {
        setBreakpoint("sm");
      } else {
        setBreakpoint("lg");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return breakpoint;
};

/***/ }),

/***/ 20984:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ InnerContentWrap)
/* harmony export */ });
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44928);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84576);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);



const InnerContentWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonStylesstyle__InnerContentWrap",
  componentId: "tfai8k-0"
})(["width:1200px;margin:0 auto;", " @media screen and ", "{width:100%;}"], p => p.theme.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MYBIZ ? `
    padding: 32px 40px;
    border-radius: 20px;
    box-shadow: 0px 3px 30px 0px #0000001A;
    background: white;` : null, _tm_static_utils__WEBPACK_IMPORTED_MODULE_1__/* .deviceType.mobile */ .vO.mobile);

/***/ }),

/***/ 84938:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ AddAlternateContact_AddAlternateContact)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddAlternateContact/AddAlternateContact.style.ts

const AccordianCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddAlternateContactstyle__AccordianCompStyle",
  componentId: "sc-1bmknqe-0"
})(["padding:16px 24px;border-bottom:1px solid #e2e2e2;display:flex;flex-direction:column;gap:20px;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddAlternateContact/AddAlternateContact.tsx






const AddAlternateContact = ({
  title,
  emailAddress,
  goBackTxt,
  handleEmailChange,
  addContactTxt,
  handleAlternateContact,
  handleAddContact,
  handleGoBack
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.CommonModalDweb, {
    handleClick: handleAlternateContact,
    customTitle: title,
    "data-test-id": "AddAlternateContact-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingInput, {
      flex: "1",
      placeholderTxt: "Enter 10 digit mobile number",
      requiredField: true,
      labelTxt: "10 Digit Mobile No.",
      inputType: "number",
      margin: "0 0 16px",
      "data-test-id": "AddAlternateContact-LandingInput"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingInput, {
      inputValue: emailAddress,
      handleChange: handleEmailChange,
      flex: "1",
      placeholderTxt: "Enter Email Id",
      requiredField: true,
      labelTxt: "Email ID",
      "data-test-id": "AddAlternateContact-LandingInput"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "32px 0 0",
      gap: "10px",
      "data-test-id": "AddAlternateContact-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        onClick: handleAddContact,
        customWidth: "210px",
        customTitle: addContactTxt,
        "data-test-id": "AddAlternateContact-LandingButton"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
        handleClick: handleGoBack,
        fontSize: "md",
        fontWeight: "bold",
        textTransform: "uppercase",
        "data-test-id": "AddAlternateContact-AnchorTag",
        children: goBackTxt
      })]
    })]
  });
};

/* harmony default export */ const AddAlternateContact_AddAlternateContact = (AddAlternateContact);

/***/ }),

/***/ 99926:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ AddPassportDetail_AddPassportDetail)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddPassportDetail/AddPassportDetail.style.ts

const AddPassportDetailStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddPassportDetailstyle__AddPassportDetailStyle",
  componentId: "sc-110cox0-0"
})(["background:#ffedd1;border:1px solid #cf8100;border-radius:16px;padding:24px 16px;gap:8px;display:flex;flex-direction:column;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddPassportDetail/AddPassportDetail.tsx






const AddPassportDetail = ({
  data,
  handlePassportBtn
}) => {
  const {
    addPasstitle,
    addPassportBtn,
    addPassInfo,
    addPassportCta
  } = data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddPassportDetailStyle, {
    "data-test-id": "AddPassportDetail-AddPassportDetailStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      fontSize: "md",
      "data-test-id": "AddPassportDetail-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: addPasstitle,
        "data-test-id": "AddPassportDetail-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButtonWhite, {
      btnLeftIcon: addPassportBtn.iconLeft,
      btnRightIcon: addPassportBtn.iconRight,
      customWidth: "100%",
      customTitle: addPassportBtn.title,
      onClick: handlePassportBtn,
      margin: "16px 0 0",
      "data-test-id": "AddPassportDetail-LandingButtonWhite"
    })]
  });
};

/* harmony default export */ const AddPassportDetail_AddPassportDetail = (AddPassportDetail);

/***/ }),

/***/ 15609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kp": () => (/* binding */ ConfirmTnc),
/* harmony export */   "L5": () => (/* binding */ AddTravellerComp),
/* harmony export */   "OX": () => (/* binding */ GenderTypeItem),
/* harmony export */   "So": () => (/* binding */ CheckoutLoaderText),
/* harmony export */   "TQ": () => (/* binding */ TravellerAddShimmer),
/* harmony export */   "UA": () => (/* binding */ PrimaryContactNote),
/* harmony export */   "XR": () => (/* binding */ ViewButtonWrap),
/* harmony export */   "_K": () => (/* binding */ CheckoutLoaderBackdrop),
/* harmony export */   "bp": () => (/* binding */ AddViewButton),
/* harmony export */   "bs": () => (/* binding */ StickyBtnWrap),
/* harmony export */   "dH": () => (/* binding */ AddTravellerDetailStyle),
/* harmony export */   "e0": () => (/* binding */ ArrowIcon),
/* harmony export */   "ef": () => (/* binding */ AddTravellerHd),
/* harmony export */   "gu": () => (/* binding */ VendorIconWrap),
/* harmony export */   "kM": () => (/* binding */ TravellerDescpStyle),
/* harmony export */   "qD": () => (/* binding */ TravellerDescpWrap),
/* harmony export */   "ql": () => (/* binding */ WebToastWrap),
/* harmony export */   "qx": () => (/* binding */ AddOnPlanWrap),
/* harmony export */   "u2": () => (/* binding */ AddButtonWrap),
/* harmony export */   "u3": () => (/* binding */ TravellerDescpError),
/* harmony export */   "uF": () => (/* binding */ ArrowButtonWrap),
/* harmony export */   "yU": () => (/* binding */ TagWrap),
/* harmony export */   "yv": () => (/* binding */ TravellerDetailsStyle),
/* harmony export */   "zX": () => (/* binding */ CheckoutLoader)
/* harmony export */ });
/* unused harmony exports SelectInsurereItem, TravellerIndexWrap */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _DatePickerComp_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85607);
/* harmony import */ var _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45590);
/* harmony import */ var _RadioButton_RadioButton_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33570);

const breakpoints = {
  lg: "992px"
};





const AddTravellerDetailStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddTravellerDetailStyle",
  componentId: "sc-1vnwff6-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;@media ", "{border-radius:16px 16px 0 0;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const AddTravellerHd = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddTravellerHd",
  componentId: "sc-1vnwff6-1"
})(["padding:30px;@media ", "{padding:24px 16px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const AddTravellerComp = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddTravellerComp",
  componentId: "sc-1vnwff6-2"
})(["padding:30px;@media ", "{padding:24px 16px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const StickyBtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__StickyBtnWrap",
  componentId: "sc-1vnwff6-3"
})(["", "{width:100%;}@media ", "{position:fixed;bottom:0;width:100%;z-index:1;background:#fff;padding:8px 16px;left:0;box-shadow:0px 1px 16px rgba(0,0,0,0.2);}"], _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingButtonStyle */ .zm, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const TravellerDetailsStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDetailsStyle",
  componentId: "sc-1vnwff6-4"
})(["padding:16px 30px;border-top:1px solid #e8e8e8;", "{span{font-size:12px;line-height:12px;}}@media ", "{padding:16px;}", "{position:absolute;top:0;right:0;}"], _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingButtonWhiteStyle */ .aA, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile, _DatePickerComp_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_3__/* .DobPickerStyle */ .wH);
const TravellerAddShimmer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerAddShimmer",
  componentId: "sc-1vnwff6-5"
})(["padding:24px 30px;border-top:1px solid #e8e8e8;display:flex;justify-content:space-between;"]);
const GenderTypeItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__GenderTypeItem",
  componentId: "sc-1vnwff6-6"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:10px 12px;cursor:pointer;", ""], p => p.selected && `
    background: var(--tm-accent-bg-color);
    border: 1px solid var(--tm-accent-color);
    border-radius: 6px;
`);
const SelectInsurereItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__SelectInsurereItem",
  componentId: "sc-1vnwff6-7"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:10px 12px;margin-bottom:8px;cursor:pointer;", " ", "{[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{top:31%;}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{top:31%;}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{top:19px;}}"], p => p.selected && `
    background: #EAF5FF;
    border: 1px solid #008CFF;
    border-radius: 6px;
`, _RadioButton_RadioButton_style__WEBPACK_IMPORTED_MODULE_5__/* .RadioButtonStyle */ .o);
const TravellerDescpWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDescpWrap",
  componentId: "sc-1vnwff6-8"
})([""]);
const TravellerDescpStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDescpStyle",
  componentId: "sc-1vnwff6-9"
})(["display:flex;align-items:baseline;gap:8px;"]);
const TravellerIndexWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerIndexWrap",
  componentId: "sc-1vnwff6-10"
})(["background:#f6f6f6;border-radius:18px;width:20px;height:20px;flex-shrink:0;display:flex;align-items:center;justify-content:center;"]);
const TravellerDescpError = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDescpError",
  componentId: "sc-1vnwff6-11"
})(["background:#fcdadb;border-radius:4px;padding:4px 8px;text-align:center;margin-top:8px;"]);
const ConfirmTnc = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__ConfirmTnc",
  componentId: "sc-1vnwff6-12"
})(["background:#f6f6f6;border-radius:6px;padding:12px 16px;font-size:14px;line-height:20px;color:#4a4a4a;margin-bottom:8px;"]);
const PrimaryContactNote = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__PrimaryContactNote",
  componentId: "sc-1vnwff6-13"
})(["background:rgba(255,237,209,1);border-radius:8px;padding:12px 16px;margin-top:16px;display:flex;flex-direction:column;gap:8px;"]);
const ArrowButtonWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "AddTravellerDetailstyle__ArrowButtonWrap",
  componentId: "sc-1vnwff6-14"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
const AddViewButton = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddViewButton",
  componentId: "sc-1vnwff6-15"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;margin:8px 0;"]);
const ArrowIcon = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "AddTravellerDetailstyle__ArrowIcon",
  componentId: "sc-1vnwff6-16"
})(["width:7px;height:7px;@media (min-width:", "){width:9px;height:9px;}margin-left:8px;transform:", ";transition:transform 0.3s ease-in-out;"], breakpoints.lg, props => props.isRotated ? "rotate(180deg)" : "rotate(0deg)");
const ViewButtonWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__ViewButtonWrap",
  componentId: "sc-1vnwff6-17"
})(["display:flex;color:", ";cursor:pointer;align-items:center;margin:0 16px 0 0;@media (min-width:", "){margin:14px 30px 14px 0;}span{font-weight:800;font-size:12px;@media (min-width:", "){font-size:14px;}}img{width:7px;height:7px;@media (min-width:", "){width:9px;height:9px;}}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.blueText */ .rS.blueText, breakpoints.lg, breakpoints.lg, breakpoints.lg);
const AddButtonWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddButtonWrap",
  componentId: "sc-1vnwff6-18"
})(["display:flex;", ";align-item:baseline;margin:14px 0px 14px 16px;@media (min-width:", "){margin:14px 33px 14px 30px;}cursor:pointer;align-items:center;img{width:14px;height:14px;@media (min-width:", "){width:16px;height:16px;}}span{font-weight:800;font-size:12px;@media (min-width:", "){font-size:14px;}}"], props => props.isDisabled ? `color: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.disabledGrey */ .rS.disabledGrey};` : `color: var(--tm-accent-color)`, breakpoints.lg, breakpoints.lg, breakpoints.lg);
const AddOnPlanWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddOnPlanWrap",
  componentId: "sc-1vnwff6-19"
})(["display:flex;flex-direction:column;justify-content:space-between;border-radius:8px;padding:12px 16px 12px 16px;border:", ";background:", ";", " position:relative;a{font-size:12px;font-weight:700;}button{span{font-size:12px;}}picture{display:flex;align-items:center;}img{border-radius:4px;}", "{position:static;width:75px;height:32px;}"], props => props.isSelected ? `1px solid #008CFF` : `1px solid #e2e2e2`, props => props.isSelected ? `linear-gradient(0deg, #EAF5FF, #EAF5FF), linear-gradient(0deg, #008CFF, #008CFF)` : `linear-gradient(0deg, #f6f6f6, #f6f6f6),linear-gradient(0deg, #e2e2e2, #e2e2e2)`, props => props.margin && `margin: ${props.margin};`, _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingButtonWhiteStyle */ .aA);
const TagWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TagWrap",
  componentId: "sc-1vnwff6-20"
})(["display:flex;background:linear-gradient(88.44deg,#12714f 0.02%,#1ca099 100.01%);padding:2px 8px 2px 8px;border-radius:16px;height:20px;color:#ffffff;align-items:center;font-size:12px;position:absolute;font-weight:700;top:-10px;transform:translateX(-50%);margin:0px 0px 0px 10px;z-index:1;@media ", "{left:11%;}@media ", "{left:16%;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.desktop, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const VendorIconWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__VendorIconWrap",
  componentId: "sc-1vnwff6-21"
})(["@media ", "{picutre{align-items:flex-start;}}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const WebToastWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__WebToastWrap",
  componentId: "sc-1vnwff6-22"
})(["div{height:40px;}@media ", "{position:fixed;bottom:108px;width:100%;& >{width:100%;}div{}}@media ", "{& > div{margin-left:30px;}div{width:502px;}position:sticky;bottom:120px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.desktop);
const CheckoutLoaderBackdrop = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__CheckoutLoaderBackdrop",
  componentId: "sc-1vnwff6-23"
})(["position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.5);z-index:9999;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
const spin = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const CheckoutLoader = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__CheckoutLoader",
  componentId: "sc-1vnwff6-24"
})(["border:8px solid #f3f3f3;border-top:8px solid #3498db;border-radius:50%;width:60px;height:60px;animation:", " 1s linear infinite;"], spin);
const CheckoutLoaderText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__CheckoutLoaderText",
  componentId: "sc-1vnwff6-25"
})(["color:#fff;margin-top:24px;font-size:20px;padding:0 50px;text-align:center;"]);

/***/ }),

/***/ 88218:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ AddTravellerDetail_AddTravellerDetailShimmer)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetail.style.ts
var AddTravellerDetail_style = __webpack_require__(15609);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDetailsShimmer.tsx






const TravellerDetailsShimmer = ({}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* TravellerDetailsStyle */.yv, {
    "data-test-id": "TravellerDetailsShimmer-TravellerDetailsStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
      width: "266px",
      height: "20px",
      margin: "0 0 16px",
      "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      gap: "16px",
      margin: "0 0 16px",
      "data-test-id": "TravellerDetailsShimmer-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
          width: "170px",
          height: "18px",
          margin: "0 0 8px",
          "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
          width: "258px",
          height: "40px",
          "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
          width: "170px",
          height: "18px",
          margin: "0 0 8px",
          "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
          width: "258px",
          height: "40px",
          "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
      width: "170px",
      height: "24px",
      margin: "0 0 8px",
      "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      gap: "8px",
      "data-test-id": "TravellerDetailsShimmer-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
        width: "77px",
        height: "36px",
        "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
        width: "77px",
        height: "36px",
        "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
        width: "77px",
        height: "36px",
        "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
      })]
    })]
  });
};

/* harmony default export */ const AddTravellerDetail_TravellerDetailsShimmer = (TravellerDetailsShimmer);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetailShimmer.tsx







const AddTravellerDetailShimmer = ({}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* AddTravellerDetailStyle */.dH, {
    "data-test-id": "AddTravellerDetailShimmer-AddTravellerDetailStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* AddTravellerHd */.ef, {
      "data-test-id": "AddTravellerDetailShimmer-AddTravellerHd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
        width: "100%",
        height: "28px",
        margin: "0 0 8px",
        "data-test-id": "AddTravellerDetailShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
        width: "266px",
        height: "16px",
        "data-test-id": "AddTravellerDetailShimmer-ShimmerVersion2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerDetailsShimmer, {
      "data-test-id": "AddTravellerDetailShimmer-TravellerDetailsShimmer"
    }), Array.from({
      length: 3
    }).map((_item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* TravellerAddShimmer */.TQ, {
      "data-test-id": "AddTravellerDetailShimmer-TravellerAddShimmer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion2, {
        width: "75px",
        height: "20px",
        "data-test-id": "AddTravellerDetailShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ShimmerVersion3, {
        width: "60px",
        height: "32px",
        "data-test-id": "AddTravellerDetailShimmer-ShimmerVersion3"
      })]
    }, `${index}`))]
  });
};

/* harmony default export */ const AddTravellerDetail_AddTravellerDetailShimmer = (AddTravellerDetailShimmer);

/***/ }),

/***/ 22821:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ AddTravellerDetail_AddTravellerDetails)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(78521);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var ui_src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 1 modules
var utility_src = __webpack_require__(97427);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(11508);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/xdmEvents.ts + 1 modules
var xdmEvents = __webpack_require__(46535);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.tsx + 1 modules
var WebToast = __webpack_require__(78891);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetail.style.ts
var AddTravellerDetail_style = __webpack_require__(15609);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerCommonComp.tsx












const TravellerCommonComp_analytics = (0,insurance/* getAnalytics */.I)();

const TravellerCommonComp = ({
  primaryContactData,
  gstInfoData,
  title,
  info,
  note,
  primaryContactDetails,
  saveFormValuesOnBlur,
  confirmTnC,
  totalAmt,
  selectedCountry,
  isLoading,
  handleBuy,
  handleTncCheckbox,
  addOnPlans,
  addOnfilters,
  handleAddOnFilters,
  handleAddOnSelect,
  handleCountryCodeModal,
  componentRef
}) => {
  const {
    control,
    formState: {
      errors
    }
  } = (0,index_esm/* useFormContext */.Gc)();
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const {
    email,
    mobile
  } = primaryContactData || {};
  const {
    gstNumber,
    companyDetails
  } = gstInfoData || {};
  const {
    0: showAddOnBenefits,
    1: setShowAddOnBenefits
  } = (0,react.useState)(-1);
  const tncError = errors.tncs?.find?.(item => item?.message); // TODO: Refactor gstInfo, PrimaryContact and SecondaryContact to use a same component wherever possible

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* AddTravellerComp */.L5, {
    ref: componentRef,
    "data-test-id": "TravellerCommonComp-AddTravellerComp",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
      margin: "0 0 16px",
      "data-test-id": "TravellerCommonComp-H5Tag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: title,
        "data-test-id": "TravellerCommonComp-FormattedText"
      })
    }), confirmTnC?.map((tnc, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
      control: control,
      name: `tncs.${index}`,
      rules: {
        required: {
          value: true,
          message: "Please confirm"
        }
      },
      render: ({
        field: {
          value
        }
      }) => /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* ConfirmTnc */.Kp, {
        "data-test-id": "TravellerCommonComp-ConfirmTnc",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.CheckButton, {
          inputId: "confirmTnC",
          handleChange: () => {
            handleTncCheckbox?.(index);
          },
          isChecked: value,
          "data-test-id": "TravellerCommonComp-CheckButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: tnc,
              "data-test-id": "TravellerCommonComp-FormattedText"
            })
          })
        })
      }),
      "data-test-id": `TravellerCommonComp-Controller-${index}`
    }, index)), confirmTnC && tncError && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      margin: "0px 0 0 4px",
      color: Global/* theme.redText2 */.rS.redText2,
      fontSize: "xs",
      "data-test-id": "TravellerCommonComp-ParaTag",
      children: tncError.message
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      margin: confirmTnC ? "16px 0 45px" : "16px 0",
      fontSize: "sm",
      color: Global/* theme.greyText7 */.rS.greyText7,
      "data-test-id": "TravellerCommonComp-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: info,
        "data-test-id": "TravellerCommonComp-FormattedText"
      })
    }), primaryContactDetails && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        flexDirection: device == "lg" ? "row" : "column",
        gap: "16px",
        "data-test-id": "TravellerCommonComp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: "primaryContactData.mobile",
          rules: {
            required: {
              value: mobile?.isRequired ?? true,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("mobile")
            },
            pattern: {
              value: new RegExp(mobile?.regex || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("mobile", mobile?.errorMessage)
            }
          },
          render: ({
            field: {
              onChange,
              onBlur,
              value
            }
          }) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.CountryCodeInput, {
            errorState: errors?.primaryContactData?.mobile?.message,
            inputValue: value,
            handleChange: onChange,
            handleBlur: () => {
              saveFormValuesOnBlur?.();
              onBlur();
            },
            placeholderTxt: mobile?.placeholder,
            requiredField: mobile?.isRequired,
            labelTxt: mobile?.title,
            inputType: "tel",
            disableState: isLoading,
            autoComplete: "off",
            flex: "1",
            inputWidth: device == "lg" ? "50%" : "100%",
            handleCountryCodeModal: handleCountryCodeModal,
            countryFlag: selectedCountry?.countryFlag,
            countryCode: selectedCountry?.countryCode || "+91",
            "data-test-id": "TravellerCommonComp-CountryCodeInput"
          }),
          "data-test-id": "TravellerCommonComp-Controller"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: "primaryContactData.email",
          rules: {
            required: {
              value: email?.isRequired ?? true,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("email")
            },
            pattern: {
              value: new RegExp(email?.regex || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("email", email?.errorMessage)
            }
          },
          render: ({
            field: {
              onChange,
              onBlur,
              value
            }
          }) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingInput, {
            inputValue: value,
            handleChange: onChange,
            handleBlur: () => {
              saveFormValuesOnBlur?.();
              onBlur();
            },
            placeholderTxt: email?.placeholder,
            requiredField: email?.isRequired,
            labelTxt: email?.title,
            errorState: errors?.primaryContactData?.email?.message,
            disableState: isLoading,
            autoComplete: "off",
            flex: "1",
            inputWidth: device == "lg" ? "50%" : "100%",
            "data-test-id": "TravellerCommonComp-LandingInput"
          }),
          "data-test-id": "TravellerCommonComp-Controller"
        })]
      }), note && /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* PrimaryContactNote */.UA, {
        "data-test-id": "TravellerCommonComp-PrimaryContactNote",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          color: Global/* theme.brownText */.rS.brownText,
          fontWeight: "bold",
          "data-test-id": "TravellerCommonComp-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: note.title,
            "data-test-id": "TravellerCommonComp-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          color: Global/* theme.brownText */.rS.brownText,
          "data-test-id": "TravellerCommonComp-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: note?.info,
            "data-test-id": "TravellerCommonComp-FormattedText"
          })
        })]
      })]
    }), gstInfoData && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        flexDirection: device == "lg" ? "row" : "column",
        gap: "16px",
        "data-test-id": "TravellerCommonComp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: "gstInfoDetails.gstNumber",
          rules: {
            required: {
              value: gstNumber?.isRequired ?? true,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("gstNumber")
            },
            pattern: {
              value: new RegExp(gstNumber?.regex || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("gstNumber", gstNumber?.errorMessage)
            }
          },
          render: ({
            field: {
              onChange,
              onBlur,
              value
            }
          }) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingInput, {
            inputValue: value,
            handleChange: onChange,
            handleBlur: () => {
              saveFormValuesOnBlur?.();
              onBlur();
            },
            placeholderTxt: gstNumber?.placeholder,
            requiredField: gstNumber?.isRequired,
            labelTxt: gstNumber?.title,
            errorState: errors?.gstInfoDetails?.gstNumber?.message,
            disableState: isLoading,
            autoComplete: "off",
            flex: "1",
            inputWidth: device == "lg" ? "50%" : "100%",
            isDisabled: gstNumber?.isEditable !== undefined ? !gstNumber.isEditable : false,
            "data-test-id": "TravellerCommonComp-LandingInput"
          }),
          "data-test-id": "TravellerCommonComp-Controller"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: "gstInfoDetails.companyDetails",
          rules: {
            required: {
              value: companyDetails?.isRequired ?? true,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("companyDetails")
            },
            pattern: {
              value: new RegExp(companyDetails?.regex || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("companyDetails", companyDetails?.errorMessage)
            }
          },
          render: ({
            field: {
              onChange,
              onBlur,
              value
            }
          }) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingInput, {
            inputValue: value,
            handleChange: onChange,
            handleBlur: () => {
              saveFormValuesOnBlur?.();
              onBlur();
            },
            placeholderTxt: companyDetails?.placeholder,
            requiredField: companyDetails?.isRequired,
            labelTxt: companyDetails?.title,
            errorState: errors?.gstInfoDetails?.companyDetails?.message,
            disableState: isLoading,
            autoComplete: "off",
            flex: "1",
            inputWidth: device == "lg" ? "50%" : "100%",
            isDisabled: companyDetails?.isEditable !== undefined ? !companyDetails.isEditable : false,
            "data-test-id": "TravellerCommonComp-LandingInput"
          }),
          "data-test-id": "TravellerCommonComp-Controller"
        })]
      }), note && /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* PrimaryContactNote */.UA, {
        "data-test-id": "TravellerCommonComp-PrimaryContactNote",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          color: Global/* theme.brownText */.rS.brownText,
          fontWeight: "bold",
          "data-test-id": "TravellerCommonComp-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: note.title,
            "data-test-id": "TravellerCommonComp-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          color: Global/* theme.brownText */.rS.brownText,
          "data-test-id": "TravellerCommonComp-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: note?.info,
            "data-test-id": "TravellerCommonComp-FormattedText"
          })
        })]
      })]
    }), confirmTnC && /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* StickyBtnWrap */.bs, {
      "data-test-id": "TravellerCommonComp-StickyBtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        isLoading: isLoading,
        onClick: handleBuy,
        customTitle: `BUY FOR ${totalAmt}`,
        "data-test-id": "TravellerCommonComp-LandingButton"
      })
    }), addOnfilters && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
      alignItems: device == "lg" ? "center" : "flex-start",
      justifyContent: "space-between",
      margin: "0 0 30px",
      gap: "10px",
      flexDirection: device == "lg" ? "row" : "column",
      "data-test-id": "TravellerCommonComp-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.Tags, {
        handleClickTab: handleAddOnFilters,
        data: addOnfilters,
        "data-test-id": "TravellerCommonComp-Tags"
      })
    }), addOnPlans && addOnPlans.map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* AddOnPlanWrap */.qx, {
        margin: item?.tag ? "20px 0px 14px 0px" : "0px 0px 14px 0px",
        isSelected: item?.isSelected,
        "data-test-id": "TravellerCommonComp-AddOnPlanWrap",
        children: [showAddOnBenefits === index && /*#__PURE__*/(0,jsx_runtime.jsx)(components.MoreBenefits, {
          data: item?.modal,
          tag: item?.tag,
          moreBenfitsTitle: "Add-Ons",
          customBtnTitle: item?.isSelected ? `Buy for ${item?.comboProductDetails?.totalAmountToPay}` : item?.modal?.buyBtn,
          isAddOnBenefits: true,
          handleClose: () => {
            setShowAddOnBenefits(-1);
          },
          handleBuyButton: () => {
            if (item?.isSelected) {
              TravellerCommonComp_analytics?.trackTravDetailsEvents({
                actionType: "Buy_in_bs"
              }, type);
              (0,XDMAnalytics.trackEvent)({
                event_detail: {
                  event_type: "action",
                  event_name: "component_cta-clicked",
                  event_value: "Buy_in_bs"
                }
              });
              handleBuy?.();
            } else {
              (0,XDMAnalytics.trackEvent)({
                event_detail: {
                  event_type: "action",
                  event_name: "component_cta-clicked",
                  event_value: "Added_in_bs"
                }
              });
              TravellerCommonComp_analytics?.trackTravDetailsEvents({
                actionType: "Added_in_bs"
              }, type);
              handleAddOnSelect?.(item?.planCode);
            }

            setShowAddOnBenefits(-1);
          },
          "data-test-id": "TravellerCommonComp-MoreBenefits"
        }), item?.tag && /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* TagWrap */.yU, {
          "data-test-id": "TravellerCommonComp-TagWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: item?.tag,
            "data-test-id": "TravellerCommonComp-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          flexDirection: "row",
          justifyContent: "space-between",
          margin: item?.tag ? "6px 0 0" : "0",
          "data-test-id": "TravellerCommonComp-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            flexDirection: "row",
            gap: device === "lg" ? "14px" : "8px",
            "data-test-id": "TravellerCommonComp-FlexComp",
            children: [item?.planIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* VendorIconWrap */.gu, {
              "data-test-id": "TravellerCommonComp-VendorIconWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                src: item?.planIcon,
                height: device === "lg" ? "48px" : "32px",
                width: device === "lg" ? "48px" : "32px",
                "data-test-id": "TravellerCommonComp-ImageComponent"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              flexDirection: "column",
              "data-test-id": "TravellerCommonComp-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: item?.primary?.title,
                baseStyle: {
                  fontSize: "14px",
                  fontWeight: "700",
                  color: Global/* theme.greyText */.rS.greyText
                },
                "data-test-id": "TravellerCommonComp-FormattedText"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
                flexDirection: device === "lg" ? "row" : "column",
                gap: device === "lg" ? "8px" : "0px",
                "data-test-id": "TravellerCommonComp-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: item?.primary?.description,
                  "data-test-id": "TravellerCommonComp-FormattedText"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
                  margin: device === "lg" ? "3px 0px 0px 0px" : "-2px 0px 0px 0px",
                  handleClick: () => {
                    TravellerCommonComp_analytics?.trackTravDetailsEvents({
                      actionType: "View_detail_clicked"
                    }, type);
                    (0,XDMAnalytics.trackEvent)({
                      event_detail: {
                        event_type: "action",
                        event_name: "component_cta-clicked",
                        event_value: "View_detail_clicked"
                      }
                    });
                    setShowAddOnBenefits(index);
                  },
                  "data-test-id": "TravellerCommonComp-AnchorTag",
                  children: item?.primary?.cta?.value
                })]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            flexDirection: device === "lg" ? "row" : "column",
            gap: device === "lg" ? "12px" : "8px",
            alignItems: " center",
            "data-test-id": "TravellerCommonComp-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              flexDirection: "column",
              "data-test-id": "TravellerCommonComp-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
                justifyContent: "right",
                alignItems: "center",
                gap: "8px",
                "data-test-id": "TravellerCommonComp-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: item?.secondary?.title,
                  baseStyle: {
                    fontSize: "14px",
                    fontWeight: "700",
                    padding: "1.5px 0px 1.5px 0px"
                  },
                  "data-test-id": "TravellerCommonComp-FormattedText"
                }), item?.isSelected && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                  src: item?.addedIcon,
                  height: "16px",
                  width: "16px",
                  "data-test-id": "TravellerCommonComp-ImageComponent"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: item?.secondary?.description,
                baseStyle: {
                  fontSize: "12px",
                  fontWeight: "400",
                  color: Global/* theme.greyText6 */.rS.greyText6
                },
                "data-test-id": "TravellerCommonComp-FormattedText"
              })]
            }), item?.isSelected ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
              handleClick: () => {
                TravellerCommonComp_analytics?.trackTravDetailsEvents({
                  actionType: "Remove_clicked"
                }, type);
                (0,XDMAnalytics.trackEvent)({
                  event_detail: {
                    event_type: "action",
                    event_name: "component_cta-clicked",
                    event_value: "Remove_clicked"
                  }
                });
                handleAddOnSelect?.(item?.planCode);
              },
              margin: "6px 12.5px 6px 12.5px",
              "data-test-id": "TravellerCommonComp-AnchorTag",
              children: item?.secondary?.cta?.toggleValue
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButtonWhite, {
              customTitle: item?.secondary?.cta?.value,
              onClick: () => {
                TravellerCommonComp_analytics?.trackTravDetailsEvents({
                  actionType: item?.addPlanEvent
                }, type);
                (0,XDMAnalytics.trackEvent)({
                  event_detail: {
                    event_type: "action",
                    event_name: "component_cta-clicked",
                    event_value: item?.addPlanEvent ? item?.addPlanEvent : "Add_button_clicked"
                  }
                });
                TravellerCommonComp_analytics?.trackTravDetailsEvents({
                  actionType: "Add_button_clicked"
                }, type);
                handleAddOnSelect?.(item?.planCode);
              },
              customHeight: "32px",
              customWidth: "75px",
              "data-test-id": "TravellerCommonComp-LandingButtonWhite"
            })]
          })]
        })]
      });
    })]
  });
};

/* harmony default export */ const AddTravellerDetail_TravellerCommonComp = (TravellerCommonComp);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDetailsV2.tsx + 1 modules
var TravellerDetailsV2 = __webpack_require__(75289);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetails.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















const AddTravellerDetails_analytics = (0,insurance/* getAnalytics */.I)();

const AddTravellerDetails = ({
  title,
  info,
  data,
  countryData,
  travellerCount,
  benefitsData,
  benefitsTitle,
  showBenefits,
  handleCountryCodeModal,
  handleViewBenefits,
  setAddOnProductDetails,
  addOnProductDetails,
  setActiveModal,
  isLoading: externalIsLoading,
  checkoutError,
  handleTravellerPayment,
  onFormDataChange,
  firstErrorIndex,
  setFirstErrorIndex,
  getSelectedCountry,
  onSetError
}) => {
  const {
    primaryContact,
    secondaryContact,
    upcomingTravellerDetails,
    savedTravellers,
    note,
    concent,
    totalAmt,
    widgets,
    isDomesticBooking,
    addOns,
    experiment,
    isSavedTravellerPokusEnabled = false,
    planInfo,
    gstInfo
  } = data || {};
  const {
    addOnPlans,
    filters
  } = addOns || {};
  const {
    dob,
    name,
    gender,
    passport,
    nomineeName
  } = secondaryContact?.fields || {};
  const {
    formErrorToast,
    addErrorToast
  } = src.constants;
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const travellerDataFromStore = (0,utils/* getTravDetailsFromMemory */.fP)();
  const {
    travellerDetails,
    primaryContactDetails,
    gstInfoDetails
  } = travellerDataFromStore || {};
  const partner = (0,utils/* getPartnerOnClientSide */.et)();
  const travellerRef = (0,react.useRef)(null);
  const travellerRefMap = (0,react.useRef)({});
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const {
    0: addTrav,
    1: setAddTrav
  } = (0,react.useState)(-1);
  const {
    0: quoteId,
    1: setQuoteId
  } = (0,react.useState)(null);
  const {
    0: isValidForm,
    1: setIsValidForm
  } = (0,react.useState)(false);
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const {
    0: isFieldError,
    1: setIsFieldError
  } = (0,react.useState)(false);
  const {
    0: showOfferToast,
    1: setShowOfferToast
  } = (0,react.useState)(true);
  const {
    0: addOnFilters,
    1: setAddOnFilters
  } = (0,react.useState)(filters);
  const {
    0: addOnPlansData,
    1: setAddOnPlansData
  } = (0,react.useState)(addOnPlans);
  const {
    0: isEligibilityLoading,
    1: setIsEligibilityLoading
  } = (0,react.useState)(false);
  const {
    0: showCheckoutLoginLoaderText,
    1: setShowCheckoutLoginLoaderText
  } = (0,react.useState)("");
  const primaryContactRef = (0,react.useRef)(null);
  const gstInfoRef = (0,react.useRef)(null);
  const tncRef = (0,react.useRef)(null);
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  (0,react.useEffect)(() => {
    setShowCheckoutLoginLoaderText("");

    if (sessionStorage.getItem("formData") && (0,utils/* getCookieByName */.A7)("mmt-auth")) {
      setShowCheckoutLoginLoaderText("Redirecting you to payment page");
      const formData = JSON.parse(sessionStorage.getItem("formData") || "{}");
      replace(formData);
      sessionStorage.removeItem("formData");
      handleTravellerPayment?.(formData);
    }

    if (isSavedTravellerPokusEnabled) {
      AddTravellerDetails_analytics?.trackTravDetailsEvents({
        actionType: "viewAll_shown"
      }, "pageView", type);
      (0,XDMAnalytics.trackComponentView)({
        name: "viewAll_shown",
        type: "button"
      });
    }

    if (planInfo?.quoteId) {
      setQuoteId(planInfo.quoteId);
    } else {
      const queryParams = new URLSearchParams(window.location.search);
      const quoteId = queryParams.get("quoteId");
      setQuoteId(quoteId);
    }

    setTimeout(() => {
      setShowOfferToast(false);
    }, 3000);
  }, []);
  const methods = (0,index_esm/* useForm */.cI)({
    defaultValues: {
      travellerData: Array.from({
        length: (savedTravellers?.length ?? 0) + travellerCount
      }).map(() => ({
        name: "",
        dob: "",
        gender: "",
        passport: "",
        nomineeName: "",
        isSelected: false
      })),
      primaryContactData: {
        email: "",
        mobile: ""
      },
      gstInfoDetails: {
        gstNumber: "",
        companyDetails: ""
      },
      tncs: Array.from({
        length: concent?.tnc?.length ?? 0
      }).map(() => true)
    },
    mode: "onTouched"
  });
  const {
    control,
    getValues,
    setValue,
    getFieldState,
    setError,
    handleSubmit,
    trigger
  } = methods;
  const formValues = getValues();
  const travellerData = (0,index_esm/* useWatch */.qo)({
    control,
    name: "travellerData" // unique name for field array

  });
  const {
    fields: travellers,
    prepend,
    replace
  } = (0,index_esm/* useFieldArray */.Dq)({
    control,
    name: "travellerData" // unique name for field array

  });
  const selectedCount = (0,react.useMemo)(() => travellerData?.filter(traveller => traveller.isSelected)?.length ?? 0, [travellerData]);
  const {
    0: showAllTravellers,
    1: setShowAllTravellers
  } = (0,react.useState)(false);
  (0,react.useMemo)(() => {
    if (selectedCount === travellerCount) {
      let isValid = true;
      travellerData?.map(data => {
        if (data.isSelected) {
          const validName = name ? data.name ? true : false : true;
          const validDob = dob ? data.dob ? true : false : true;
          const validPassport = dob ? data.passport ? true : false : true;
          const validGender = gender ? data?.gender ? true : false : true;
          const validNomineeName = nomineeName ? data?.nomineeName ? true : false : true;

          if (!(validDob && validGender && validName && validPassport && validNomineeName)) {
            isValid = false;
          }
        }
      });
      setIsValidForm(isValid);
    } else {
      setIsValidForm(false);
    }
  }, [travellerData]); // To add saved travellers and upcoming travellers in memory

  (0,react.useEffect)(() => {
    let travellerDetail = [];
    const queryParams = new URLSearchParams(window.location.search);

    if (!travellerDetails?.length || queryParams.get("isUpcomingTrip") === "true") {
      if (queryParams.get("isUpcomingTrip") === "true" || savedTravellers?.length === 0) {
        upcomingTravellerDetails?.map(data => {
          travellerDetail.push(_objectSpread(_objectSpread({}, data), {}, {
            dob: parseInt(data.dob),
            gender: data.gender.charAt(0).toUpperCase() + data.gender.slice(1).toLowerCase(),
            isSelected: queryParams.get("isUpcomingTrip") === "true"
          }));
        });
      }

      savedTravellers?.map(data => {
        travellerDetail.push(_objectSpread(_objectSpread({}, data), {}, {
          gender: data.gender.charAt(0).toUpperCase() + data.gender.slice(1).toLowerCase(),
          isSelected: data?.isDefaultSelected || false,
          isSavedTraveller: true,
          isEdited: false
        }));
      });
      (0,utils/* setTravDetailsInMemory */.Yp)(_objectSpread(_objectSpread({}, travellerDataFromStore), {}, {
        travellerDetails: travellerDetail,
        primaryContactDetails: primaryContact,
        gstInfoDetails: gstInfo
      }));

      if (travellerDetail.length === 0) {
        setAddTrav(0);
      }
    } else {
      const selectedTravellersInMemory = travellerDetails?.filter(data => data.isSelected);
      const remainingTravellersInMemory = travellerDetails?.filter(data => !data.isSelected);
      const queryParams = new URLSearchParams(window.location.search);
      const travellers = Number(queryParams.get("travellers"));
      travellerDetail.push(...selectedTravellersInMemory.slice(0, travellers), ...selectedTravellersInMemory.slice(travellers).map(data => {
        return _objectSpread(_objectSpread({}, data), {}, {
          isSelected: false
        });
      }), ...remainingTravellersInMemory);
    }

    let length = travellerDetail?.length ? travellerDetail?.length : upcomingTravellerDetails?.length ? upcomingTravellerDetails?.length : 1;
    setValue("travellerData", Array.from({
      length: length
    }).map((_, index) => ({
      name: travellerDetail?.[index]?.name || "",
      dob: travellerDetail?.[index]?.isSavedTraveller ? travellerDetail?.[index]?.dob || "" : travellerDetail?.[index]?.dob || "yyyy-mm-dd",
      gender: travellerDetail?.[index]?.gender || "",
      passport: travellerDetail?.[index]?.passport || "",
      nomineeName: travellerDetail?.[index]?.nomineeName || "",
      isSelected: travellerDetail?.[index]?.isSelected ?? true,
      isEdited: travellerDetail?.[index]?.isEdited ?? true,
      isSavedTraveller: travellerDetail?.[index]?.isSavedTraveller ?? false
    })));
  }, [secondaryContact, savedTravellers, upcomingTravellerDetails]);
  (0,react.useEffect)(() => {
    setValue("primaryContactData", {
      mobile: primaryContactDetails?.mobile || primaryContact?.fields?.mobile?.value || "",
      email: primaryContactDetails?.email || primaryContact?.fields?.email?.value || ""
    });
  }, [primaryContact]);
  (0,react.useEffect)(() => {
    setValue("gstInfoDetails", {
      gstNumber: gstInfoDetails?.gstNumber || gstInfo?.fields?.gstNumber?.value || "",
      companyDetails: gstInfoDetails?.companyDetails || gstInfo?.fields?.companyDetails?.value || ""
    });
  }, [gstInfo]);
  const selectedCountry = (0,react.useMemo)(() => {
    return countryData?.find(item => item.isSelected);
  }, [countryData]);

  const handleArrowButton = index => {
    if (addTrav === index) {
      setAddTrav(-1);

      if (travellerData?.[index].isSelected) {
        trigger(`travellerData.${index}`);
      }
    } else {
      setAddTrav(index);
    }
  };

  const handleGenderChange = (data, index) => {
    setValue(`travellerData.${index}.gender`, data.label);
  };

  const saveFormValuesOnBlur = (index = -1) => {
    if (index != -1 && !getValues(`travellerData.${index}.isEdited`)) {
      setValue(`travellerData.${index}.isEdited`, true);
    }

    const {
      travellerData,
      primaryContactData,
      gstInfoDetails
    } = formValues;
    (0,utils/* setTravDetailsInMemory */.Yp)(_objectSpread(_objectSpread({}, travellerDataFromStore), {}, {
      travellerDetails: travellerData,
      primaryContactDetails: primaryContactData,
      gstInfoDetails: gstInfoDetails
    }));
  };

  const handleTncCheckbox = index => {
    const value = formValues.tncs[index];
    setValue(`tncs.${index}`, !value);
    trigger(`tncs.${index}`);
  };

  const handleErrorToast = () => {
    setTimeout(() => {
      setIsSelectedError(false);
      setIsFieldError(false);
    }, 3000);
  };

  const scrollToTravellerWithPartiallyVisible = index => {
    const element = travellerRefMap.current?.[index];

    if (element) {
      const elementRect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight; // Check if element is partially visible

      const isPartiallyVisible = elementRect.bottom > windowHeight - 200;

      if (isPartiallyVisible) {
        const scrollTarget = window.pageYOffset + 200;
        window.scrollTo({
          top: scrollTarget,
          behavior: "smooth"
        });
      }
    }
  };

  const scrollToTravellerWithOffset = index => {
    const element = travellerRefMap.current?.[index];

    if (element) {
      const elementRect = element.getBoundingClientRect();
      const offsetTop = elementRect.top + window.pageYOffset - 100;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    }
  };

  const handleTravellerSelect = (value, index) => {
    if (getValues(`travellerData.${index}.isSelected`)) {
      setAddTrav(-1);
      setValue(`travellerData.${index}.isSelected`, false);
    } else {
      if (selectedCount === travellerCount) {
        if (!isSelectedError) {
          setIsSelectedError(true);
          handleErrorToast();
        }
      } else {
        setAddTrav(index);
        setValue(`travellerData.${index}.isSelected`, true);
        scrollToTravellerWithPartiallyVisible(index);
      }
    }
  };

  const onSubmit = async formData => {
    if (onFormDataChange) {
      onFormDataChange(formData);
    }

    if (getSelectedCountry) {
      getSelectedCountry(selectedCountry);
    }

    AddTravellerDetails_analytics?.trackTravDetailsEvents({
      actionType: "traveller_name_filled"
    }, "pageView", type);
    AddTravellerDetails_analytics?.trackTravDetailsEvents({
      actionType: "contact_details_filled"
    }, "pageView", type);
    AddTravellerDetails_analytics?.trackTravDetailsEvents({
      actionType: "dob_selected"
    }, "pageView", type);
    AddTravellerDetails_analytics?.trackTravDetailsEvents({
      actionType: "gender_selected"
    }, "pageView", type);
    (0,XDMAnalytics.trackComponentView)({
      name: "traveller_name_filled",
      type: "submit"
    });
    (0,XDMAnalytics.trackComponentView)({
      name: "contact_details_filled",
      type: "submit"
    });
    (0,XDMAnalytics.trackComponentView)({
      name: "dob_selected",
      type: "submit"
    });
    (0,XDMAnalytics.trackComponentView)({
      name: "gender_selected",
      type: "submit"
    });
    const partner = (0,utils/* getPartnerOnClientSide */.et)();
    let shouldLogin = false;
    const countryCode = selectedCountry?.countryCode ? selectedCountry.countryCode.replace(/^\+/, "") : "";

    if (!(0,utils/* getCookieByName */.A7)("mmt-auth") && !(0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO")) {
      shouldLogin = true;
      setIsEligibilityLoading(true);
      const eligibilityResponse = await (0,api/* checkCheckoutEligibility */.HL)({
        partner,
        query: {
          itineraryId: new URLSearchParams(window.location.search).get("itineraryId") || ""
        },
        phone: countryCode + formData?.primaryContactData?.mobile || "",
        email: formData?.primaryContactData?.email || ""
      });

      if (eligibilityResponse?.responseStatus === src.RESPONSE_STATUS.SUCCESS) {
        shouldLogin = eligibilityResponse?.data?.isLoginRequired;
      }

      setIsEligibilityLoading(false);
    } // triggerPageExit();


    if (shouldLogin) {
      setIsLoading(false);

      if (device === "sm" && partner === src.PARTNER.MMT) {
        setShowCheckoutLoginLoaderText("Redirecting you to login to complete your purchase");
        setTimeout(() => {
          sessionStorage.setItem("formData", JSON.stringify(formData));
          const req = {
            url: window.location.pathname + window.location.search
          };
          document.cookie = "loginActionDetails=" + JSON.stringify(req.url) + ";domain=.makemytrip.com;path=/";
          window.location.href = "https://www.makemytrip.com/pwa/hlp/v3/login";
        }, 3000);
      } else {
        setActiveModal("LOGIN");
      }
    } else {
      (0,analytics/* storePageTransitionStart */.SE)("traveller_details");
      await handleTravellerPayment?.(formData);
      return;
    }
  };

  const handleAddTraveller = () => {
    if (selectedCount != travellerCount) {
      setAddTrav(0);
      prepend({
        name: "",
        dob: "yyyy-mm-dd",
        gender: "",
        passport: "",
        nomineeName: "",
        isSelected: true
      });
      setTimeout(() => {
        scrollToTravellerWithOffset(0);
      }, 100);
    }
  };

  const handleXDMErrorTrack = errors => {
    const errorXDMArr = []; // Process tncs errors

    if (errors.tncs && Array.isArray(errors.tncs)) {
      errors.tncs.forEach(error => {
        errorXDMArr.push({
          message: error.message,
          source: error.ref?.name || "tncs",
          severity: "P3"
        });
      });
    } // Process travellerData errors


    if (errors.travellerData && Array.isArray(errors.travellerData)) {
      errors.travellerData.forEach((travellerError, index) => {
        Object.keys(travellerError).forEach(fieldKey => {
          const fieldError = travellerError[fieldKey];
          errorXDMArr.push({
            message: fieldError.message,
            source: `travellerData.${index + 1}.${fieldKey}`,
            severity: "P3"
          });
        });
      });
    } // Process primaryContactData errors


    if (errors.primaryContactData && typeof errors.primaryContactData === "object") {
      Object.keys(errors.primaryContactData).forEach(fieldKey => {
        const fieldError = errors.primaryContactData[fieldKey];
        errorXDMArr.push({
          message: fieldError.message,
          source: fieldError.ref?.name || `primaryContactData.${fieldKey}`,
          severity: "P3"
        });
      });
    } // Process gstInfoDetails errors (if any)


    if (errors.gstInfoDetails && typeof errors.gstInfoDetails === "object") {
      Object.keys(errors.gstInfoDetails).forEach(fieldKey => {
        const fieldError = errors.gstInfoDetails[fieldKey];

        if (fieldError && fieldError.message) {
          errorXDMArr.push({
            message: fieldError.message,
            source: fieldError.ref?.name || `gstInfoDetails.${fieldKey}`,
            severity: "P3"
          });
        }
      });
    }

    if (errorXDMArr.length > 0) {
      (0,xdmEvents/* errorTrackEvent */.t1)({
        error_details_list: errorXDMArr
      });
    }
  };

  const onSubmitError = errors => {
    if (!isFieldError) {
      setIsFieldError(true);
      handleErrorToast();
    }

    handleXDMErrorTrack(errors);

    if (errors.travellerData?.length) {
      const errorIndex = errors.travellerData?.findIndex?.(error => error);

      if (errorIndex != null && errorIndex > -1) {
        setFirstErrorIndex(errorIndex);
      }
    } else if (errors.primaryContactData?.email || errors.primaryContactData?.mobile) {
      primaryContactRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "center"
      });
    } else if (errors.tncs?.length) {
      tncRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center"
      });
    } else if (errors.gstInfoDetails?.gstNumber || errors.gstInfoDetails?.companyDetails) {
      gstInfoRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "center"
      });
    }
  };

  (0,react.useEffect)(() => {
    if (firstErrorIndex > -1) {
      travellerRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
      setAddTrav(-1);
    }

    setFirstErrorIndex(-1);
  }, [firstErrorIndex]);

  const filterTravellers = async (selected, errors) => {
    let targetPosition = 0;
    const newIndices = new Array(travellers.length);
    const errorIndices = errors.map(err => err.index);
    travellers.forEach((traveller, index) => {
      if (errorIndices.includes(index)) {
        newIndices[index] = targetPosition;
        targetPosition++;
      }
    });
    travellers.forEach((traveller, index) => {
      if (selected.includes(index) && !errorIndices.includes(index)) {
        newIndices[index] = targetPosition;
        targetPosition++;
      }
    });
    travellers.forEach((traveller, index) => {
      if (!selected.includes(index) && !errorIndices.includes(index)) {
        newIndices[index] = targetPosition;
        targetPosition++;
      }
    });
    const newArray = [];
    newIndices.forEach((indexVal, index) => {
      newArray[indexVal] = getValues(`travellerData.${index}`);
    });
    replace(newArray);
    const isValid = await trigger("travellerData");
    errors.forEach(({
      index,
      errorType
    }, ind) => {
      const fieldKey = `travellerData.${ind}.${errorType}`;
      setError(fieldKey, {
        message: (0,utils/* getFormFieldErrorMsg */.YV)(errorType)
      });
    });
  };

  const handleBuy = (fromBenefitModal = false) => {
    if (externalIsLoading || isEligibilityLoading) {
      return;
    }

    if (showBenefits) {
      handleViewBenefits();
    }

    if (selectedCount !== travellerCount) {
      if (!isFieldError) {
        setIsFieldError(true);
        (0,xdmEvents/* errorTrackEvent */.t1)({
          error_details_list: [{
            message: "Please Select Traveller",
            source: "traveller_select",
            severity: "P3"
          }]
        });
        setFirstErrorIndex(0);
        handleErrorToast();
      }
    } else {
      if (isDomesticBooking) {
        if (fromBenefitModal) {
          AddTravellerDetails_analytics?.trackTravDetailsEvents({
            actionType: "buy_clicked_details_domestic"
          }, "pageView", type);
          (0,XDMAnalytics.trackEvent)({
            event_detail: {
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: "buy_clicked_details_domestic"
            }
          });
        } else {
          (0,XDMAnalytics.trackEvent)({
            event_detail: {
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: "buy_clicked_outside_domestic"
            }
          });
          AddTravellerDetails_analytics?.trackTravDetailsEvents({
            actionType: "buy_clicked_outside_domestic"
          }, "pageView", type);
        }
      } else {
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "buy_clicked"
          }
        });
        AddTravellerDetails_analytics?.trackTravDetailsEvents({
          actionType: "buy_clicked"
        }, "pageView", type);
      }

      const formValues = getValues();
      const selected = [];
      const errorArr = []; // const errorXDMArr: any[] = [];

      formValues?.travellerData?.map((item, index) => {
        const {
          name: fullName,
          dob: dobValue,
          gender: genderType,
          passport: passportType,
          nomineeName: nomineeNameType,
          isSelected
        } = item || {};

        if (isSelected) {
          selected.push(index);
        }

        const fieldState = getFieldState(`travellerData.${index}`);
        const {
          isTouched
        } = fieldState;

        if (!isTouched) {
          if (name && name?.isRequired && !fullName) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "name"
              });
            }
          } else if (dob && dob?.isRequired && !dobValue) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "dob"
              });
            }
          } else if (gender && gender?.isRequired && !genderType) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "gender"
              });
            }
          } else if (passport && passport?.isRequired && !passportType) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "passport"
              });
            }
          } else if (nomineeName && nomineeName?.isRequired && !nomineeNameType) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "nomineeName"
              });
            }
          }
        }
      });
      filterTravellers(selected, errorArr);
      handleSubmit(onSubmit, onSubmitError)();
    }
  };

  if (checkoutError && true) {
    throw new utility_src/* ClientError */.XF(checkoutError);
  }

  const handleAddOnFilters = selectedFilterId => {
    AddTravellerDetails_analytics?.trackTravDetailsEvents({
      actionType: "Filter_selected"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "Filter_selected"
      }
    });
    const filterData = filters?.map(filter => {
      if (filter.id === selectedFilterId) {
        filter.isSelected = true;
      } else {
        filter.isSelected = false;
      }

      return filter;
    });
    const selectedFilteredPlans = filterData?.filter(filter => filter.isSelected)?.[0]?.plans;
    let currentAddOnPlans = addOnPlans?.map(plan => {
      if (selectedFilteredPlans?.includes(plan?.planCode)) {
        return plan;
      } else {
        return null;
      }
    })?.filter(plan => plan !== null);
    setAddOnPlansData(currentAddOnPlans);
    setAddOnFilters(filterData);
  };

  const handleAddOnSelect = planCode => {
    const selectedFilteredPlans = addOnFilters?.filter(filter => filter.isSelected)?.[0]?.plans;
    const addOnData = addOnPlans?.map((plan, index) => {
      if (plan?.planCode === planCode) {
        if (plan.isSelected) {
          const queryParams = new URLSearchParams(window.location.search);
          const quoteId = queryParams.get("quoteId");
          setQuoteId(quoteId);
          plan.isSelected = false;
        } else {
          setQuoteId(plan?.quoteId);
          plan.isSelected = true;
        }
      } else {
        plan.isSelected = false;
      }

      return plan;
    })?.filter(plan => selectedFilteredPlans?.includes(plan?.planCode));
    const selectedAddOnProdDetails = addOnPlans?.filter(plan => plan?.isSelected)?.[0]?.comboProductDetails;

    if (selectedAddOnProdDetails) {
      setAddOnProductDetails?.(selectedAddOnProdDetails);
    } else {
      setAddOnProductDetails?.(null);
    }

    setAddOnPlansData(addOnData);
  };

  const handleViewTraveller = () => {
    if (showAllTravellers) {
      AddTravellerDetails_analytics?.trackTravDetailsEvents({
        actionType: "viewLessButton_clicked"
      }, "pageView", type);
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "viewLessButton_clicked"
        }
      });
    } else {
      AddTravellerDetails_analytics?.trackTravDetailsEvents({
        actionType: "viewAllButton_clicked"
      }, "pageView", type);
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "viewAllButton_clicked"
        }
      });
    }

    setShowAllTravellers(!showAllTravellers);
  };

  const getVisibleTravellers = () => {
    if (isSavedTravellerPokusEnabled) {
      return showAllTravellers ? travellers : travellers.slice(0, 5);
    }

    return travellers;
  };

  (0,react.useEffect)(() => {
    if (onSetError) {
      setError(onSetError?.errTrype, onSetError?.errName);
    }
  }, [onSetError, setError]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
    "data-test-id": "AddTravellerDetails-FormProvider",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* AddTravellerDetailStyle */.dH, {
      "data-test-id": "AddTravellerDetails-AddTravellerDetailStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* AddTravellerHd */.ef, {
        "data-test-id": "AddTravellerDetails-AddTravellerHd",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
          "data-test-id": "AddTravellerDetails-H5Tag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: title,
            "data-test-id": "AddTravellerDetails-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          fontSize: "xs",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "AddTravellerDetails-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: info,
            "data-test-id": "AddTravellerDetails-FormattedText"
          })
        })]
      }), getVisibleTravellers().map((traveller, index) => {
        const {
          gender,
          isSelected
        } = formValues?.travellerData?.[index] || {};
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: el => travellerRefMap.current[index] = el,
          "data-test-id": "AddTravellerDetails",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TravellerDetailsV2/* default */.Z, {
            type: type,
            handleTravellerSelect: handleTravellerSelect,
            travellerIndex: index,
            travellerRef: travellerRef,
            isLoading: isLoading,
            firstErrorIndex: firstErrorIndex,
            travellerSelected: addTrav == index,
            isSelected: isSelected,
            count: selectedCount,
            travellerNumber: `${secondaryContact?.title} ${index + 1}`,
            isSavedTravellers: savedTravellers?.length ? true : false,
            secondaryContactData: secondaryContact?.fields,
            genderTypes: secondaryContact?.fields?.gender?.values || src.GENDER_VALUES,
            selectedGender: gender,
            handleGenderChange: item => handleGenderChange(item, index),
            handleArrowButton: () => handleArrowButton(index),
            travellerCount: travellerCount,
            saveFormValuesOnBlur: saveFormValuesOnBlur,
            isDomesticBooking: isDomesticBooking,
            isValidForm: isValidForm,
            isEditable: secondaryContact?.isEditable === false ? false : true,
            partner: partner,
            "data-test-id": "AddTravellerDetails-TravellerDetailsV2"
          })
        }, traveller.id);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SectionDividers, {
        height: "1.2px",
        "data-test-id": "AddTravellerDetails-SectionDividers"
      }), !isDomesticBooking && /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* AddViewButton */.bp, {
        "data-test-id": "AddTravellerDetails-AddViewButton",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* AddButtonWrap */.u2, {
          isDisabled: selectedCount === travellerCount,
          onClick: handleAddTraveller,
          "data-test-id": "AddTravellerDetails-AddButtonWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "16px",
            height: "16px",
            margin: "0px 10px 0px 0px",
            src: selectedCount === travellerCount ? "https://tripmoneycmsimgak.mmtcdn.com/img/Vector_529ac663fb.svg" : partner === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Vector_3e57c47aa3.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Vector_68e1489f3a.svg",
            "data-test-id": "AddTravellerDetails-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: "ADD ANOTHER TRAVELLER",
            baseStyle: {
              fontWeight: "800"
            },
            "data-test-id": "AddTravellerDetails-FormattedText"
          })]
        }), isSavedTravellerPokusEnabled && travellers.length > 5 && /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* ViewButtonWrap */.XR, {
          onClick: handleViewTraveller,
          "data-test-id": "AddTravellerDetails-ViewButtonWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: showAllTravellers ? "VIEW LESS" : "VIEW ALL",
            baseStyle: {
              fontWeight: "800"
            },
            "data-test-id": "AddTravellerDetails-FormattedText"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* ArrowIcon */.e0, {
            isRotated: showAllTravellers,
            src: partner === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_2e09571187.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
            alt: "View toggle icon",
            "data-test-id": "AddTravellerDetails-ArrowIcon"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SectionDividers, {
        small: true,
        "data-test-id": "AddTravellerDetails-SectionDividers"
      }), addOns && /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerCommonComp, {
        title: addOns?.title,
        info: addOns?.subTitle,
        addOnPlans: addOnPlansData,
        addOnfilters: addOnFilters,
        handleBuy: handleBuy,
        handleAddOnFilters: handleAddOnFilters,
        handleAddOnSelect: handleAddOnSelect,
        "data-test-id": "AddTravellerDetails-TravellerCommonComp"
      }), addOns && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SectionDividers, {
        small: true,
        "data-test-id": "AddTravellerDetails-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerCommonComp, {
        componentRef: primaryContactRef,
        title: primaryContact?.title,
        info: primaryContact?.info,
        note: isDomesticBooking ? undefined : note,
        primaryContactDetails: true,
        primaryContactData: primaryContact?.fields,
        saveFormValuesOnBlur: saveFormValuesOnBlur,
        countryData: countryData,
        selectedCountry: selectedCountry,
        handleCountryCodeModal: handleCountryCodeModal,
        "data-test-id": "AddTravellerDetails-TravellerCommonComp"
      }), gstInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SectionDividers, {
        small: true,
        "data-test-id": "AddTravellerDetails-SectionDividers"
      }), gstInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerCommonComp, {
        componentRef: gstInfoRef,
        title: gstInfo?.title,
        gstInfoData: gstInfo?.fields,
        saveFormValuesOnBlur: saveFormValuesOnBlur,
        "data-test-id": "AddTravellerDetails-TravellerCommonComp"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SectionDividers, {
        small: true,
        "data-test-id": "AddTravellerDetails-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerCommonComp, {
        componentRef: tncRef,
        confirmTnC: concent?.tnc,
        handleTncCheckbox: handleTncCheckbox,
        info: isDomesticBooking ? "" : concent?.info,
        totalAmt: addOnProductDetails?.totalAmountToPay ? addOnProductDetails?.totalAmountToPay : totalAmt,
        handleBuy: () => {
          handleBuy();
        },
        isLoading: isLoading,
        "data-test-id": "AddTravellerDetails-TravellerCommonComp"
      })]
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
      toastTxt: `Already selected ${travellerCount} ${travellerCount === 1 ? "traveller" : "travellers"}, Remove before adding one.`,
      position: "fixed",
      right: "50px",
      margin: device === "lg" ? "0px 0px 0px 28px" : "",
      height: "40px",
      bottom: device === "sm" ? "70px" : "50px",
      "data-test-id": "AddTravellerDetails-WebToast"
    }), isFieldError && /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* WebToastWrap */.ql, {
      "data-test-id": "AddTravellerDetails-WebToastWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
        type: "error",
        toastTxt: selectedCount === travellerCount ? widgets?.formErrorToast ? widgets?.formErrorToast?.message : formErrorToast : widgets?.addErrorToast ? widgets?.addErrorToast?.message : addErrorToast,
        color: "#6B4300",
        "data-test-id": "AddTravellerDetails-WebToast"
      })
    }), widgets?.offerToast && showOfferToast && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
      type: "success",
      iconUrl: widgets?.offerToast?.iconUrl,
      toastTxt: widgets?.offerToast?.message,
      position: "fixed",
      toastTxtMargin: "0px 0px 0px 5px",
      color: "#1E5C43",
      fontSize: "14px",
      fontWeight: "700",
      right: "50px",
      bottom: device === "sm" ? "70px" : "50px",
      "data-test-id": "AddTravellerDetails-WebToast"
    }), showBenefits && /*#__PURE__*/(0,jsx_runtime.jsx)(components.MoreBenefits, {
      data: benefitsData,
      moreBenfitsTitle: benefitsTitle,
      handleClose: handleViewBenefits,
      handleBuyButton: () => {
        handleBuy(true);
      },
      "data-test-id": "AddTravellerDetails-MoreBenefits"
    }), showCheckoutLoginLoaderText && /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* CheckoutLoaderBackdrop */._K, {
      "data-test-id": "AddTravellerDetails-CheckoutLoaderBackdrop",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* CheckoutLoader */.zX, {
        "data-test-id": "AddTravellerDetails-CheckoutLoader"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* CheckoutLoaderText */.So, {
        "data-test-id": "AddTravellerDetails-CheckoutLoaderText",
        children: showCheckoutLoginLoaderText
      })]
    })]
  }));
};

/* harmony default export */ const AddTravellerDetail_AddTravellerDetails = (AddTravellerDetails);

/***/ }),

/***/ 75289:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ AddTravellerDetail_TravellerDetailsV2)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetail.style.ts
var AddTravellerDetail_style = __webpack_require__(15609);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDescpV2.tsx










const TravellerDescp = ({
  travellerIndex,
  genderTypeSelected,
  secondaryContactData,
  isSelected,
  handleEditState,
  isDomesticBooking,
  partner
}) => {
  const {
    name,
    dob,
    gender,
    passport,
    nomineeName
  } = secondaryContactData || {};
  const {
    control,
    formState: {
      errors
    }
  } = (0,index_esm/* useFormContext */.Gc)();
  const error = errors?.travellerData?.[travellerIndex];
  let errorMessage = error?.name?.message || error?.dob?.message || error?.gender?.message || error?.passport?.message || error?.nomineeName?.message || "";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* TravellerDescpWrap */.qD, {
    "data-test-id": "TravellerDescp-TravellerDescpWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* TravellerDescpStyle */.kM, {
      "data-test-id": "TravellerDescp-TravellerDescpStyle",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        flex: "auto",
        alignItems: "baseline",
        justifyContent: "space-between",
        "data-test-id": "TravellerDescp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
          "data-test-id": "TravellerDescp-SpanTag",
          children: [name && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            control: control,
            name: `travellerData.${travellerIndex}.name`,
            rules: {
              required: {
                value: isSelected ? name?.isRequired ?? true : false,
                message: (0,utils/* getFormFieldErrorMsg */.YV)("name")
              },
              pattern: isSelected ? {
                value: new RegExp(name?.regex || ""),
                message: (0,utils/* getFormFieldErrorMsg */.YV)("name", name?.errorMessage)
              } : undefined
            },
            render: ({
              field: {
                value
              }
            }) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "sm",
              fontWeight: "black",
              margin: "0 0 2px",
              "data-test-id": "TravellerDescp-SpanTag",
              children: value || "Traveller " + (travellerIndex + 1).toString()
            }),
            "data-test-id": "TravellerDescp-Controller"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [gender && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                control: control,
                name: `travellerData.${travellerIndex}.gender`,
                rules: {
                  required: {
                    value: isSelected ? gender?.isRequired ?? true : false,
                    message: (0,utils/* getFormFieldErrorMsg */.YV)("gender")
                  }
                },
                render: ({
                  field: {
                    value
                  }
                }) => /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
                  fontSize: "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "TravellerDescp-SpanTag",
                  children: [isDomesticBooking && "GENDER: ", value ? value : "---"]
                }),
                "data-test-id": "TravellerDescp-Controller"
              })
            }), dob && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: `travellerData.${travellerIndex}.dob`,
              rules: {
                required: isSelected && (dob?.isRequired ?? false) ? {
                  value: true,
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("dob")
                } : false,
                validate: isSelected && (dob?.isRequired ?? false) ? value => (0,utils/* isDobValid */.qP)(value, dob?.regex) || (0,utils/* getFormFieldErrorMsg */.YV)("dob", dob?.errorMessage) : undefined
              },
              render: ({
                field: {
                  value
                }
              }) => /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
                fontSize: "xs",
                color: Global/* theme.greyText */.rS.greyText,
                "data-test-id": "TravellerDescp-SpanTag",
                children: [", DOB:", " ", (0,utils/* formatDate */.p6)(value, src.DATE_FORMATS["DD/MM/YYYY"]) || "---"]
              }),
              "data-test-id": "TravellerDescp-Controller"
            }), passport && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: `travellerData.${travellerIndex}.passport`,
              rules: {
                required: {
                  value: isSelected ? passport?.isRequired ?? true : false,
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("passport")
                },
                pattern: isSelected ? {
                  value: new RegExp(passport?.regex || ""),
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("passport", passport?.errorMessage)
                } : undefined
              },
              render: ({
                field: {
                  value
                }
              }) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                fontSize: "xs",
                color: Global/* theme.greyText */.rS.greyText,
                "data-test-id": "TravellerDescp-SpanTag",
                children: value ? `, Passport: ${value}` : ""
              }),
              "data-test-id": "TravellerDescp-Controller"
            }), nomineeName && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: `travellerData.${travellerIndex}.nomineeName`,
              rules: {
                required: {
                  value: isSelected ? nomineeName?.isRequired ?? true : false,
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("nomineeName")
                },
                pattern: isSelected ? {
                  value: new RegExp(nomineeName?.regex || ""),
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("nomineeName", nomineeName?.errorMessage)
                } : undefined
              },
              render: ({
                field: {
                  value
                }
              }) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                fontSize: "xs",
                color: Global/* theme.greyText */.rS.greyText,
                "data-test-id": "TravellerDescp-SpanTag",
                children: value ? `, Nominee Name: ${value}` : ""
              }),
              "data-test-id": "TravellerDescp-Controller"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* ArrowButtonWrap */.uF, {
          onClick: handleEditState,
          "data-test-id": "TravellerDescp-ArrowButtonWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "9px",
            height: "9px",
            margin: "0px 0px 0px 0px",
            src: partner === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_2e09571187.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
            "data-test-id": "TravellerDescp-ImageComponent"
          })
        })]
      })
    }), errorMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* TravellerDescpError */.u3, {
      "data-test-id": "TravellerDescp-TravellerDescpError",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        color: Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "TravellerDescp-SpanTag",
        children: errorMessage
      })
    })]
  });
};

/* harmony default export */ const TravellerDescpV2 = (TravellerDescp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDetailsV2.tsx















const minDate = (0,utils/* subtractYrsFromDate */.rv)(new Date(), 70).toISOString().split("T")[0];
const maxDate = new Date().toISOString().split("T")[0];
const analytics = (0,insurance/* getAnalytics */.I)();

const TravellerDetailsV2 = ({
  type,
  travellerIndex,
  count,
  travellerRef,
  isLoading,
  firstErrorIndex,
  travellerNumber,
  genderTypes,
  handleArrowButton,
  travellerSelected,
  handleGenderChange,
  handleTravellerSelect,
  selectedGender,
  saveFormValuesOnBlur,
  secondaryContactData,
  isSelected,
  travellerCount,
  isSavedTravellers,
  isValidForm,
  isEditable,
  isDomesticBooking,
  partner
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    control,
    formState: {
      errors
    },
    getValues
  } = (0,index_esm/* useFormContext */.Gc)();
  const error = errors?.travellerData?.[travellerIndex];
  const {
    name,
    dob,
    gender,
    passport,
    nomineeName
  } = secondaryContactData || {};
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetail_style/* TravellerDetailsStyle */.yv, {
    ref: travellerIndex === firstErrorIndex ? travellerRef : null,
    "data-traveller-index": travellerIndex,
    "data-test-id": "TravellerDetailsV2-TravellerDetailsStyle",
    children: [travellerIndex === 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      alignItems: "center",
      justifyContent: "space-between",
      margin: "0px 0px 20px 0px",
      "data-test-id": "TravellerDetailsV2-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: isSavedTravellers ? "Saved Travellers" : "Travellers",
        baseStyle: {
          color: "#4A4A4A",
          fontSize: "14px",
          fontWeight: "700"
        },
        "data-test-id": "TravellerDetailsV2-FormattedText"
      }), travellerCount && travellerCount > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: count?.toString() + "/" + travellerCount?.toString() + " Added",
        baseStyle: {
          color: isValidForm ? "#2B825E" : "#757575",
          fontSize: "14px",
          fontWeight: "700"
        },
        "data-test-id": "TravellerDetailsV2-FormattedText"
      }) : null]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
      control: control,
      name: `travellerData.${travellerIndex}.isSelected`,
      render: ({
        field: {
          value
        }
      }) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.CheckButton, {
        isChecked: value,
        isDisabled: !isEditable,
        handleChange: () => {
          if (!isEditable) return; //TODO: create a wrapper for omniture and XDM and call it instead of calling individually everywhere

          const selectionAction = value ? `traveller_${travellerIndex}_deselected` : `traveller_${travellerIndex}_selected`;
          analytics?.trackTravDetailsEvents({
            actionType: value ? `traveller_${travellerIndex}_deselected` : `traveller_${travellerIndex}_selected`
          });
          (0,XDMAnalytics.trackEvent)({
            event_detail: {
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: selectionAction
            }
          });

          if (!value && getValues(`travellerData.${travellerIndex}.isSavedTraveller`)) {
            if (getValues(`travellerData.${travellerIndex}.isEdited`)) {
              analytics?.trackTravDetailsEvents({
                actionType: "saved_traveller_edit_clicked"
              }, "pageView", type);
              (0,XDMAnalytics.trackEvent)({
                event_detail: {
                  event_type: "action",
                  event_name: "component_cta-clicked",
                  event_value: "saved_traveller_edit_clicked"
                }
              });
            } else {
              analytics?.trackTravDetailsEvents({
                actionType: "saved_traveller_clicked"
              }, "pageView", type);
              (0,XDMAnalytics.trackEvent)({
                event_detail: {
                  event_type: "action",
                  event_name: "component_cta-clicked",
                  event_value: "saved_traveller_clicked"
                }
              });
            }
          }

          handleTravellerSelect && handleTravellerSelect(value, travellerIndex);
          saveFormValuesOnBlur();
        },
        "data-test-id": "TravellerDetailsV2-CheckButton",
        children: !travellerSelected ? /*#__PURE__*/(0,jsx_runtime.jsx)(TravellerDescpV2, {
          travellerIndex: travellerIndex,
          isSelected: isSelected,
          saveFormValuesOnBlur: saveFormValuesOnBlur,
          travellerNumber: travellerIndex + 1,
          genderTypeSelected: selectedGender,
          isDomesticBooking: isDomesticBooking,
          secondaryContactData: secondaryContactData,
          handleEditState: handleArrowButton,
          partner: partner,
          "data-test-id": "TravellerDetailsV2-TravellerDescp"
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          alignItems: "center",
          justifyContent: "space-between",
          "data-test-id": "TravellerDetailsV2-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H6Tag, {
            "data-test-id": "TravellerDetailsV2-H6Tag",
            children: travellerNumber
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* ArrowButtonWrap */.uF, {
            onClick: handleArrowButton,
            "data-test-id": "TravellerDetailsV2-ArrowButtonWrap",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              width: "9px",
              height: "9px",
              margin: "0px 0px 0px 0px",
              src: travellerSelected ? partner === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_db78b6056e.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg" : partner === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_2e09571187.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
              "data-test-id": "TravellerDetailsV2-ImageComponent"
            })
          })]
        })
      }),
      "data-test-id": "TravellerDetailsV2-Controller"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: travellerSelected && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          flexDirection: device == "lg" ? "row" : "column",
          margin: "16px 0 16px",
          gap: "16px",
          "data-test-id": "TravellerDetailsV2-FlexComp",
          children: [name && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            control: control,
            name: `travellerData.${travellerIndex}.name`,
            rules: {
              required: {
                value: isSelected ? name?.isRequired ?? true : false,
                message: (0,utils/* getFormFieldErrorMsg */.YV)("name")
              },
              pattern: isSelected ? {
                value: new RegExp(name?.regex || ""),
                message: (0,utils/* getFormFieldErrorMsg */.YV)("name", name?.errorMessage)
              } : undefined
            },
            render: ({
              field: {
                value,
                onChange,
                onBlur
              }
            }) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingInput, {
              flex: "1",
              requiredField: name?.isRequired,
              placeholderTxt: name?.placeholder,
              labelTxt: name?.title,
              inputValue: value,
              errorState: isSelected ? error?.name?.message : undefined,
              disableState: isLoading,
              handleChange: onChange,
              handleBlur: () => {
                saveFormValuesOnBlur(travellerIndex);
                onBlur();
              },
              autoComplete: "off",
              inputWidth: "100%",
              isDisabled: !isEditable,
              "data-test-id": "TravellerDetailsV2-LandingInput"
            }),
            "data-test-id": "TravellerDetailsV2-Controller"
          }), dob && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            control: control,
            name: `travellerData.${travellerIndex}.dob`,
            rules: {
              required: isSelected && (dob?.isRequired ?? false) ? {
                value: true,
                message: (0,utils/* getFormFieldErrorMsg */.YV)("dob")
              } : false,
              validate: isSelected && (dob?.isRequired ?? false) ? value => (0,utils/* isDobValid */.qP)(value, dob?.regex) || (0,utils/* getFormFieldErrorMsg */.YV)("dob", dob?.errorMessage) : undefined
            },
            render: ({
              field: {
                value,
                onChange,
                onBlur
              }
            }) => {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingInput, {
                flex: "1",
                placeholderTxt: dob?.placeholder,
                requiredField: dob?.isRequired,
                labelTxt: dob?.title,
                inputType: "date",
                inputValue: (0,utils/* formatDate */.p6)(value, src.DATE_FORMATS["YYYY-MM-DD"]),
                minValue: minDate,
                maxValue: maxDate,
                errorState: isSelected ? error?.dob?.message : undefined,
                disableState: isLoading,
                handleChange: onChange,
                handleBlur: () => {
                  saveFormValuesOnBlur(travellerIndex);
                  onBlur();
                },
                inputWidth: "100%",
                "data-test-id": "TravellerDetailsV2-LandingInput"
              });
            },
            "data-test-id": "TravellerDetailsV2-Controller"
          })]
        }), gender && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
            margin: "0 0 8px",
            fontSize: "md",
            fontWeight: "bold",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "TravellerDetailsV2-SpanTag",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: gender?.title,
              "data-test-id": "TravellerDetailsV2-FormattedText"
            }), gender?.isRequired && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontWeight: "bold",
              color: Global/* theme.redText2 */.rS.redText2,
              "data-test-id": "TravellerDetailsV2-SpanTag",
              children: "*"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
            gap: "8px",
            margin: passport?.isEnabled ? "0 0 16px" : "0",
            "data-test-id": "TravellerDetailsV2-FlexComp",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: `travellerData.${travellerIndex}.gender`,
              rules: {
                required: {
                  value: isSelected ? gender?.isRequired ?? true : false,
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("gender")
                }
              },
              render: ({
                field: {
                  value
                }
              }) => /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: genderTypes?.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_style/* GenderTypeItem */.OX, {
                  selected: item.label === value,
                  onClick: () => {
                    handleGenderChange(item, travellerIndex);
                    saveFormValuesOnBlur(travellerIndex);
                  },
                  "data-test-id": "TravellerDetailsV2-GenderTypeItem",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.RadioButton, {
                    activeBtn: item.label === value,
                    "data-test-id": "TravellerDetailsV2-RadioButton",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                      fontSize: "xs",
                      fontWeight: "bold",
                      color: item.label === value ? `var(--tm-accent-color)` : Global/* theme.greyText */.rS.greyText,
                      "data-test-id": "TravellerDetailsV2-SpanTag",
                      children: item.label
                    })
                  })
                }, item.id))
              }),
              "data-test-id": "TravellerDetailsV2-Controller"
            })
          })]
        }), passport && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: `travellerData.${travellerIndex}.passport`,
          rules: {
            required: {
              value: isSelected ? passport?.isRequired ?? true : false,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("passport")
            },
            pattern: isSelected ? {
              value: new RegExp(passport.regex || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("passport", passport?.errorMessage)
            } : undefined
          },
          render: ({
            field: {
              onChange,
              onBlur,
              value
            }
          }) => /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingInput, {
              requiredField: passport?.isRequired,
              placeholderTxt: passport?.placeholder,
              labelTxt: passport?.title,
              errorState: isSelected ? error?.passport?.message : undefined,
              inputValue: value,
              disableState: isLoading,
              handleChange: onChange,
              handleBlur: () => {
                saveFormValuesOnBlur(travellerIndex);
                onBlur();
              },
              autoComplete: "off",
              inputWidth: "100%",
              isDisabled: !isEditable,
              margin: "16px 0 0",
              "data-test-id": "TravellerDetailsV2-LandingInput"
            })
          }),
          "data-test-id": "TravellerDetailsV2-Controller"
        }), nomineeName && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: `travellerData.${travellerIndex}.nomineeName`,
          rules: {
            required: {
              value: isSelected ? nomineeName?.isRequired ?? true : false,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("nomineeName")
            },
            pattern: isSelected ? {
              value: new RegExp(nomineeName.regex || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("nomineeName", nomineeName?.errorMessage)
            } : undefined
          },
          render: ({
            field: {
              onChange,
              onBlur,
              value
            }
          }) => /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingInput, {
              requiredField: nomineeName?.isRequired,
              placeholderTxt: nomineeName?.placeholder,
              labelTxt: nomineeName?.title,
              errorState: isSelected ? error?.nomineeName?.message : undefined,
              inputValue: value,
              disableState: isLoading,
              handleChange: onChange,
              handleBlur: () => {
                saveFormValuesOnBlur(travellerIndex);
                onBlur();
              },
              autoComplete: "off",
              inputWidth: "100%",
              isDisabled: !isEditable,
              margin: "16px 0 0",
              "data-test-id": "TravellerDetailsV2-LandingInput"
            })
          }),
          "data-test-id": "TravellerDetailsV2-Controller"
        })]
      })
    })]
  });
};

/* harmony default export */ const AddTravellerDetail_TravellerDetailsV2 = (TravellerDetailsV2);

/***/ }),

/***/ 80330:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ AddTravellerDetailsComp_AddTravellerDetailsComp)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/ErrorIcon.tsx
var ErrorIcon = __webpack_require__(44567);
// EXTERNAL MODULE: ../../libs/ui/src/lib/contexts/index.ts + 1 modules
var contexts = __webpack_require__(40752);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDetailsV2.tsx + 1 modules
var TravellerDetailsV2 = __webpack_require__(75289);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ExcelUpload/ExcelUpload.constants.ts
var ExcelUpload_constants = __webpack_require__(98276);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetailsComp/AddTravellerDetailsComp.styles.ts


const AddTravContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__AddTravContainer",
  componentId: "ayrc8r-0"
})(["background:#ffffff;border-radius:16px;padding:24px;"]);
const AddTravHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__AddTravHeader",
  componentId: "ayrc8r-1"
})(["display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:16px;"]);
const Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__Separator",
  componentId: "ayrc8r-2"
})(["height:1px;background:#d8d8d8;margin:16px 0;"]);
const ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "AddTravellerDetailsCompstyles__ArrowButtonWrap",
  componentId: "ayrc8r-3"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
const AddViewButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__AddViewButton",
  componentId: "ayrc8r-4"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;margin:8px 0;"]);
const ExcelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__ExcelWrapper",
  componentId: "ayrc8r-5"
})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:center;gap:16px;margin:8px 0;border-radius:16px;background:", ";padding:12px;"], Global/* theme.disabledGrey2 */.rS.disabledGrey2);
const ButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__ButtonWrap",
  componentId: "ayrc8r-6"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;gap:16px;margin:8px 0;width:100%;"]);
const ExcelPersuasion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__ExcelPersuasion",
  componentId: "ayrc8r-7"
})(["display:flex;cursor:default;justify-content:center;margin:8px 0;width:100%;padding:12px;background:", ";border-radius:16px;font-size:16px;font-weight:700;color:", ";"], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blackText */.rS.blackText);
const AddButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__AddButtonWrap",
  componentId: "ayrc8r-8"
})(["display:flex;", ";align-item:baseline;margin:14px 33px 14px 30px;cursor:pointer;align-items:center;img{width:16px;height:16px;}span{font-weight:800;font-size:14px;}"], props => props.isDisabled ? `color: ${Global/* theme.disabledGrey */.rS.disabledGrey};` : `color: ${Global/* theme.blueText */.rS.blueText}`);
const ViewButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__ViewButtonWrap",
  componentId: "ayrc8r-9"
})(["display:flex;color:", ";cursor:pointer;align-items:center;margin:14px 30px 14px 0;span{font-weight:800;font-size:14px;}img{width:9px;height:9px;}"], Global/* theme.blueText */.rS.blueText);
const ArrowIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "AddTravellerDetailsCompstyles__ArrowIcon",
  componentId: "ayrc8r-10"
})(["width:9px;height:9px;margin-left:8px;transform:", ";transition:transform 0.3s ease-in-out;"], props => props.isRotated ? "rotate(180deg)" : "rotate(0deg)");
const ExcelErrorMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailsCompstyles__ExcelErrorMessage",
  componentId: "ayrc8r-11"
})(["display:flex;align-items:center;justify-content:center;gap:6px;width:100%;svg{flex-shrink:0;}span{font-size:12px;color:", ";}"], Global/* theme.redText2 */.rS.redText2);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetailsComp/AddTravellerDetailsComp.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















const ExcelUpload = /*#__PURE__*/(0,react.lazy)(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 87080)));

const AddTravellerDetailsComp = data => {
  const queryParams = new URLSearchParams(window.location.search);
  const quoteId = queryParams.get("quoteId") || "";
  const itineraryId = queryParams.get("itineraryId") || "";
  const {
    0: localAddTrav,
    1: setLocalAddTrav
  } = (0,react.useState)(-1);
  const travellerIndex = 0;
  const {
    formValues,
    title,
    subTitle,
    savedTravellers,
    secondaryContact,
    addTravellerCTA,
    isPassportMandatory,
    travellerCount = 1,
    setValue,
    firstErrorIndex,
    setFirstErrorIndex,
    isLoading = false,
    onPayment,
    primaryContactRef,
    tncRef,
    isDomesticBooking = false,
    expandedTravellerIndex,
    setExpandedTravellerIndex,
    setSecondaryContactFields,
    visibleTravellersCount,
    excelSectionData,
    onExcelFileUploaded,
    forceShowAllTravellers
  } = data;

  const scrollToTravellerWithOffset = index => {
    const element = travellerRefMap.current?.[index];

    if (element) {
      const elementRect = element.getBoundingClientRect();
      const offsetTop = elementRect.top + window.pageYOffset - 100;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    }
  }; // Use external expanded state if provided, otherwise use local state


  const addTrav = expandedTravellerIndex !== undefined ? expandedTravellerIndex : localAddTrav;
  const setAddTrav = setExpandedTravellerIndex || setLocalAddTrav; // Sync local state with external state when external state changes

  (0,react.useEffect)(() => {
    if (expandedTravellerIndex !== undefined && expandedTravellerIndex !== localAddTrav) {
      setLocalAddTrav(expandedTravellerIndex);
    }
  }, [expandedTravellerIndex, localAddTrav]);
  const analytics = (0,insurance/* getAnalytics */.I)();
  const {
    0: showAllTravellers,
    1: setShowAllTravellers
  } = (0,react.useState)(false); // Show all travellers when parent forces it (e.g., when error is on non-visible traveller)

  (0,react.useEffect)(() => {
    if (forceShowAllTravellers) {
      setShowAllTravellers(true);
    }
  }, [forceShowAllTravellers]);
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const {
    0: isFieldError,
    1: setIsFieldError
  } = (0,react.useState)(false);
  const {
    0: excelUploadError,
    1: setExcelUploadError
  } = (0,react.useState)("");
  const {
    0: excelUploadInfo,
    1: setExcelUploadInfo
  } = (0,react.useState)("");
  const {
    0: downloadTemplateError,
    1: setDownloadTemplateError
  } = (0,react.useState)("");
  const {
    0: excelTotalCount,
    1: setExcelTotalCount
  } = (0,react.useState)(0);
  const {
    0: travellerDataFromStore,
    1: setTravellerDataFromStore
  } = (0,react.useState)({});
  const {
    travellerDetails
  } = travellerDataFromStore || {}; // Read session storage only after client-side hydration

  (0,react.useEffect)(() => {
    const dataFromStorage = (0,utils/* getTravDetailsFromMemory */.fP)();
    setTravellerDataFromStore(dataFromStorage);
  }, []);
  (0,react.useEffect)(() => {
    if (excelSectionData) {
      analytics?.trackTravDetailsEvents({
        actionType: "download_template_shown"
      });
      analytics?.trackTravDetailsEvents({
        actionType: "upload_template_shown"
      });
      (0,XDMAnalytics.trackComponentView)({
        name: "download_template_shown",
        type: "view"
      });
      (0,XDMAnalytics.trackComponentView)({
        name: "upload_template_shown",
        type: "view"
      });
    }
  }, [excelSectionData]); // Handle firstErrorIndex - scroll to error traveller when index changes

  (0,react.useEffect)(() => {
    if (firstErrorIndex && firstErrorIndex > -1) {
      travellerRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
      setAddTrav(-1);
    }

    if (setFirstErrorIndex) {
      setFirstErrorIndex(-1);
    }
  }, [firstErrorIndex, setFirstErrorIndex]);
  (0,react.useEffect)(() => {
    let travellerDetail = [];
    const queryParams = new URLSearchParams(window.location.search);
    setSecondaryContactFields(secondaryContact?.fields);

    if (!travellerDetails?.length || queryParams.get("isUpcomingTrip") === "true") {
      savedTravellers?.map(data => {
        travellerDetail.push(_objectSpread(_objectSpread({}, data), {}, {
          gender: data.gender.charAt(0).toUpperCase() + data.gender.slice(1).toLowerCase(),
          isSelected: false,
          isSavedTraveller: true,
          isEdited: false
        }));
      });
      (0,utils/* setTravDetailsInMemory */.Yp)(_objectSpread(_objectSpread({}, travellerDataFromStore), {}, {
        travellerDetails: travellerDetail
      })); // Only expand first traveller if no excelSectionData (since we won't have default empty traveller)

      if (travellerDetail.length === 0 && !excelSectionData) {
        setAddTrav(0);
      }
    } else if (travellerDetails && travellerDetails.length > 0) {
      // Use existing session storage data when available
      // This preserves user's exact form data including names, DOB, etc.
      travellerDetail = [...travellerDetails];
    } else {
      // Fallback to create new traveller entries if session storage is empty/undefined
      const queryParams = new URLSearchParams(window.location.search);
      const travellers = Number(queryParams.get("travellers"));
      const travellercount = travellerCount || travellers || 1;
      travellerDetail = Array.from({
        length: travellercount
      }).map(() => ({
        name: "",
        dob: "",
        gender: "",
        isSelected: true,
        isEdited: true,
        isSavedTraveller: false,
        passport: "",
        nomineeName: ""
      }));
    } // If excelSectionData is present, don't create default empty traveller


    let length = travellerDetail?.length ? travellerDetail?.length : excelSectionData ? 0 : 1;
    const formData = Array.from({
      length: length
    }).map((_, index) => ({
      name: travellerDetail?.[index]?.name || "",
      dob: travellerDetail?.[index]?.isSavedTraveller ? travellerDetail?.[index]?.dob || "" : travellerDetail?.[index]?.dob || "yyyy-mm-dd",
      gender: travellerDetail?.[index]?.gender || "",
      passport: travellerDetail?.[index]?.passport || "",
      nomineeName: travellerDetail?.[index]?.nomineeName || "",
      isSelected: travellerDetail?.[index]?.isSelected ?? true,
      isEdited: travellerDetail?.[index]?.isEdited ?? true,
      isSavedTraveller: travellerDetail?.[index]?.isSavedTraveller ?? false
    }));
    setValue("travellerData", formData);
  }, [secondaryContact, savedTravellers, travellerDataFromStore]);
  const {
    control,
    formState: {
      errors
    },
    getValues,
    trigger,
    getFieldState,
    setError,
    clearErrors,
    handleSubmit
  } = (0,index_esm/* useFormContext */.Gc)();
  const {
    type
  } = (0,contexts/* usePlanType */.U)();
  const {
    fields: travellers,
    prepend,
    replace
  } = (0,index_esm/* useFieldArray */.Dq)({
    control,
    name: "travellerData"
  });

  const handleErrorToast = () => {
    setTimeout(() => {
      setIsSelectedError(false);
      setIsFieldError(false);
    }, 3000);
  };

  const handleGenderChange = (data, index) => {
    setValue(`travellerData.${index}.gender`, data.label);
  };

  const saveFormValuesOnBlur = (index = -1) => {
    if (index != -1 && !getValues(`travellerData.${index}.isEdited`)) {
      setValue(`travellerData.${index}.isEdited`, true);
    }

    const {
      travellerData,
      primaryContactData
    } = formValues;
    (0,utils/* setTravDetailsInMemory */.Yp)(_objectSpread(_objectSpread({}, travellerDataFromStore), {}, {
      travellerDetails: travellerData,
      primaryContactDetails: primaryContactData
    }));
  };

  const handleArrowButton = index => {
    if (addTrav === index) {
      setAddTrav(-1);

      if (travellerData?.[index].isSelected) {
        trigger(`travellerData.${index}`);
      }
    } else {
      setAddTrav(index);
    }
  };

  const error = errors?.travellerData?.[travellerIndex];
  const travellerRefMap = (0,react.useRef)({});
  const travellerData = (0,index_esm/* useWatch */.qo)({
    control,
    name: "travellerData"
  });
  const selectedCount = (0,react.useMemo)(() => travellerData?.filter(traveller => traveller.isSelected)?.length ?? 0, [travellerData]); // Check if any selected traveller has missing mandatory field data

  const hasMissingMandatoryData = (0,react.useMemo)(() => {
    if (!travellerData) return false;
    const {
      name,
      dob,
      gender,
      passport,
      nomineeName
    } = secondaryContact?.fields || {};
    return travellerData.some(traveller => {
      if (!traveller.isSelected) return false; // Check each mandatory field

      if (name?.isRequired && !traveller.name?.trim()) return true;
      if (dob?.isRequired && (!traveller.dob || traveller.dob === "yyyy-mm-dd")) return true;
      if (gender?.isRequired && !traveller.gender?.trim()) return true;
      if (passport?.isRequired && !traveller.passport?.trim()) return true;
      if (nomineeName?.isRequired && !traveller.nomineeName?.trim()) return true;
      return false;
    });
  }, [travellerData, secondaryContact?.fields]); // Helper to replace all placeholders consistently
  // Placeholder convention: {X} = uploaded/selected, {Y} = remaining, {Z} = total, {W} = duplicates

  const replaceAllPlaceholders = (message, x, y, z, w = 0) => message?.replace("{X}", x?.toString() || "0")?.replace("{Y}", y?.toString() || "0")?.replace("{Z}", z?.toString() || "0")?.replace("{W}", w?.toString() || "0"); // Compute the message to display in ExcelPersuasion


  const excelPersuasionMessage = (0,react.useMemo)(() => {
    const isExcelBypass = excelSectionData?.upload?.isExcelBypass;
    const remaining = travellerCount - selectedCount;

    if (isExcelBypass) {
      return excelSectionData?.bypassInfo;
    } // Highest priority: Excel had more travellers than needed (only first X were added)


    if (selectedCount === travellerCount && excelTotalCount > travellerCount) {
      return replaceAllPlaceholders(excelSectionData?.info?.traveller_added_first, selectedCount, remaining, travellerCount);
    }

    if (selectedCount === travellerCount) {
      if (hasMissingMandatoryData) {
        return replaceAllPlaceholders(excelSectionData?.info?.details_missing, selectedCount, 0, travellerCount);
      }

      return replaceAllPlaceholders(excelSectionData?.info?.traveller_added, selectedCount, 0, travellerCount);
    }

    if (excelUploadInfo && !excelUploadError) {
      return excelUploadInfo;
    }

    return replaceAllPlaceholders(excelSectionData?.info?.traveller_input, selectedCount, remaining, travellerCount);
  }, [excelSectionData, selectedCount, travellerCount, hasMissingMandatoryData, excelUploadInfo, excelUploadError, excelTotalCount]);

  const getVisibleTravellers = () => {
    return showAllTravellers ? travellers : travellers.slice(0, visibleTravellersCount);
  };

  const travellerRef = (0,react.useRef)(null);

  const filterTravellers = async (selected, errors) => {
    let targetPosition = 0;
    const newIndices = new Array(travellers.length);
    const errorIndices = errors.map(err => err.index);
    travellers.forEach((traveller, index) => {
      if (errorIndices.includes(index)) {
        newIndices[index] = targetPosition;
        targetPosition++;
      }
    });
    travellers.forEach((traveller, index) => {
      if (selected.includes(index) && !errorIndices.includes(index)) {
        newIndices[index] = targetPosition;
        targetPosition++;
      }
    });
    travellers.forEach((traveller, index) => {
      if (!selected.includes(index) && !errorIndices.includes(index)) {
        newIndices[index] = targetPosition;
        targetPosition++;
      }
    });
    const newArray = [];
    newIndices.forEach((indexVal, index) => {
      newArray[indexVal] = getValues(`travellerData.${index}`);
    });
    replace(newArray);
    const isValid = await trigger("travellerData"); // If there are errors, show all travellers to make error travellers visible

    if (errors.length > 0) {
      setShowAllTravellers(true);
    }

    errors.forEach(({
      index,
      errorType
    }, ind) => {
      const fieldKey = `travellerData.${ind}.${errorType}`;
      setError(fieldKey, {
        message: (0,utils/* getFormFieldErrorMsg */.YV)(errorType)
      });
    });
  };

  const handleTravellerSelect = (value, index) => {
    if (getValues(`travellerData.${index}.isSelected`)) {
      setAddTrav(-1);
      setValue(`travellerData.${index}.isSelected`, false); // Clear excel upload info so message falls back to dynamic count

      setExcelUploadInfo("");
      setExcelTotalCount(0);
    } else {
      if (selectedCount === travellerCount) {
        if (!isSelectedError) {
          setIsSelectedError(true);
          handleErrorToast();
        }
      } else {
        setAddTrav(index);
        setValue(`travellerData.${index}.isSelected`, true); // Clear excel upload info so message falls back to dynamic count

        setExcelUploadInfo("");
        setExcelTotalCount(0);
      }
    }
  };

  const handleExcelDataParsed = (data, duplicatesRemoved = 0, file) => {
    analytics?.trackTravDetailsEvents({
      actionType: "upload_template_clicked"
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "upload_template_clicked"
      }
    }); // Notify parent about the uploaded file

    if (file) {
      onExcelFileUploaded?.(file);
    } // Clear any previous error/info


    setExcelUploadError("");
    setExcelUploadInfo(""); // Clear all previous traveller validation errors

    clearErrors("travellerData"); // Get info messages config

    const infoMessages = excelSectionData?.info; // Get current traveller data

    const currentTravellerData = getValues("travellerData") || []; // Remove previously uploaded Excel travellers and deselect the remaining ones

    const deselectedTravellers = currentTravellerData.filter(traveller => !traveller.isExcelUploaded).map(traveller => _objectSpread(_objectSpread({}, traveller), {}, {
      isSelected: false
    })); // Pick only top (travellerCount) travellers from Excel

    const travellersToAdd = data.slice(0, travellerCount);
    const totalFromExcel = data.length;
    const addedCount = travellersToAdd.length; // Store total from Excel for use in dynamic messages

    setExcelTotalCount(totalFromExcel); // Map Excel data to form traveller format

    const newTravellers = travellersToAdd.map(traveller => ({
      name: traveller.name || "",
      dob: traveller.dob || "yyyy-mm-dd",
      gender: traveller.gender ? traveller.gender.charAt(0).toUpperCase() + traveller.gender.slice(1).toLowerCase() : "",
      passport: traveller.passport || "",
      nomineeName: traveller.nomineeName || "",
      isSelected: true,
      isEdited: true,
      isSavedTraveller: false,
      isExcelUploaded: true
    })); // Replace all travellers: new Excel travellers (selected) at top + existing deselected travellers

    const updatedTravellerDetails = [...newTravellers, ...deselectedTravellers];
    replace(updatedTravellerDetails); // Save to session storage

    (0,utils/* setTravDetailsInMemory */.Yp)(_objectSpread(_objectSpread({}, travellerDataFromStore), {}, {
      travellerDetails: updatedTravellerDetails
    })); // Collapse all traveller cards

    setAddTrav(-1); // Set appropriate info message

    const stillNeeded = travellerCount - addedCount;

    if (addedCount < totalFromExcel) {
      // Only first X travellers were added (due to limit) - highest priority
      setExcelUploadInfo(replaceAllPlaceholders(infoMessages.traveller_added_first, addedCount, stillNeeded, travellerCount, duplicatesRemoved));
    } else if (duplicatesRemoved > 0) {
      // Duplicates were removed
      setExcelUploadInfo(replaceAllPlaceholders(infoMessages.traveller_added_duplicate, addedCount, stillNeeded, travellerCount, duplicatesRemoved));
    } else if (addedCount === travellerCount) {
      // All required travellers added successfully
      setExcelUploadInfo(replaceAllPlaceholders(infoMessages.traveller_added, addedCount, stillNeeded, travellerCount, duplicatesRemoved));
    } else if (stillNeeded > 0) {
      // Partial add - need more travellers
      setExcelUploadInfo(replaceAllPlaceholders(infoMessages.traveller_added_partial, addedCount, stillNeeded, travellerCount, duplicatesRemoved));
    } else {
      // All required travellers added
      setExcelUploadInfo(replaceAllPlaceholders(infoMessages.traveller_added, addedCount, stillNeeded, travellerCount, duplicatesRemoved));
    }
  };

  const handleExcelError = (errorCode, missingFields) => {
    // Clear any info message and download template error when there's an upload error
    setExcelUploadInfo("");
    setDownloadTemplateError("");
    const errorMessages = excelSectionData?.errors; // Map error codes to display messages

    const errorCodeToMessage = {
      [ExcelUpload_constants/* ExcelUploadErrorCode.FILE_SIZE_EXCEEDED */.rW.FILE_SIZE_EXCEEDED]: errorMessages.file_size_exceeds,
      [ExcelUpload_constants/* ExcelUploadErrorCode.UNSUPPORTED_FILE_TYPE */.rW.UNSUPPORTED_FILE_TYPE]: errorMessages.unsupported_file_type,
      [ExcelUpload_constants/* ExcelUploadErrorCode.UNABLE_TO_READ_FILE */.rW.UNABLE_TO_READ_FILE]: errorMessages.unable_to_read_file,
      [ExcelUpload_constants/* ExcelUploadErrorCode.NO_DETAILS_FOUND */.rW.NO_DETAILS_FOUND]: errorMessages.no_details_found,
      [ExcelUpload_constants/* ExcelUploadErrorCode.TOO_MANY_ROWS */.rW.TOO_MANY_ROWS]: errorMessages.no_details_found,
      [ExcelUpload_constants/* ExcelUploadErrorCode.FILE_FORMAT_ERROR */.rW.FILE_FORMAT_ERROR]: errorMessages.file_format,
      [ExcelUpload_constants/* ExcelUploadErrorCode.FIELDS_MISSING */.rW.FIELDS_MISSING]: errorMessages.fields_missing,
      [ExcelUpload_constants/* ExcelUploadErrorCode.UNKNOWN_ERROR */.rW.UNKNOWN_ERROR]: errorMessages.file_format
    };
    let mappedError = errorCodeToMessage[errorCode] || errorMessages.file_format; // Handle missing fields with capitalized field names

    if (errorCode === ExcelUpload_constants/* ExcelUploadErrorCode.FIELDS_MISSING */.rW.FIELDS_MISSING && missingFields) {
      const fieldNameMap = {
        name: "Name",
        dob: "DOB",
        gender: "Gender",
        passport: "Passport",
        nomineename: "Nominee Name"
      };
      const capitalizedFields = missingFields.map(f => fieldNameMap[f.toLowerCase()] || f.charAt(0).toUpperCase() + f.slice(1)).join(", ");
      mappedError = mappedError.replace("{fields}", capitalizedFields);
    } // Track excel error analytics


    analytics?.trackTravDetailsEvents({
      actionType: "error_shown",
      payload: `excel | ${mappedError}`
    });
    setExcelUploadError(mappedError);
  };

  const handleDownloadTemplate = async () => {
    analytics?.trackTravDetailsEvents({
      actionType: "download_template_clicked"
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "download_template_clicked"
      }
    }); // Clear previous errors

    setDownloadTemplateError("");
    setExcelUploadError("");

    try {
      await (0,utils/* downloadTemplate */.fQ)(itineraryId);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Failed to download template";
      setDownloadTemplateError(errorMessage); // Clear upload error when download error occurs

      setExcelUploadError("");
      console.error("Failed to download template:", error);
    }
  };

  const handleAddTraveller = () => {
    analytics?.trackTravDetailsEvents({
      actionType: "Add_another_traveller_clicked"
    });

    if (selectedCount != travellerCount) {
      setAddTrav(0);
      prepend({
        name: "",
        dob: "yyyy-mm-dd",
        gender: "",
        passport: "",
        nomineeName: "",
        isSelected: true
      });
      setTimeout(() => {
        scrollToTravellerWithOffset(0);
      }, 100);
    }
  };

  const handleViewTraveller = () => {
    analytics?.trackTravDetailsEvents({
      actionType: showAllTravellers ? "viewLessButton_clicked" : "viewAllButton_clicked"
    });
    setShowAllTravellers(!showAllTravellers);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravContainer, {
    "data-test-id": "AddTravellerDetailsComp-AddTravContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravHeader, {
      "data-test-id": "AddTravellerDetailsComp-AddTravHeader",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        flexDirection: "column",
        gap: "8px",
        "data-test-id": "AddTravellerDetailsComp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: title,
          baseStyle: {
            fontSize: "22px",
            fontWeight: "900",
            color: "#000000"
          },
          "data-test-id": "AddTravellerDetailsComp-FormattedText"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: subTitle,
          baseStyle: {
            fontSize: "14px",
            fontWeight: "400",
            color: "#4a4a4a"
          },
          "data-test-id": "AddTravellerDetailsComp-FormattedText"
        })]
      }), travellerCount && travellerCount > 0 && !excelSectionData?.upload?.isExcelBypass ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: selectedCount?.toString() + "/" + travellerCount?.toString() + " Added",
        baseStyle: {
          color: "#757575",
          fontSize: "14px",
          fontWeight: "700"
        },
        "data-test-id": "AddTravellerDetailsComp-FormattedText"
      }) : null]
    }), excelSectionData && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Separator, {
        "data-test-id": "AddTravellerDetailsComp-Separator"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ExcelWrapper, {
        "data-test-id": "AddTravellerDetailsComp-ExcelWrapper",
        children: [excelSectionData.description && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          baseStyle: {
            fontSize: "14px",
            fontWeight: "400",
            color: "#4a4a4a"
          },
          value: excelSectionData.description,
          "data-test-id": "AddTravellerDetailsComp-FormattedText"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonWrap, {
          "data-test-id": "AddTravellerDetailsComp-ButtonWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButtonTertiary, {
            title: excelSectionData.download?.btnText || "Download Template",
            onClick: handleDownloadTemplate,
            disableState: false,
            "data-test-id": "AddTravellerDetailsComp-LandingButtonTertiary"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
            fallback: null,
            "data-test-id": "AddTravellerDetailsComp-Suspense",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExcelUpload, {
              onDataParsed: handleExcelDataParsed,
              onError: handleExcelError,
              isExcelBypass: excelSectionData.upload?.isExcelBypass,
              maxFileSizeMB: excelSectionData.upload?.maxFileSizeMB,
              maxRows: excelSectionData.upload?.maxRows,
              buttonText: excelSectionData.upload?.buttonText,
              requiredFields: excelSectionData.upload?.requiredFields,
              errorMessages: excelSectionData.errors,
              hideError: true,
              quoteId: quoteId,
              itineraryId: itineraryId,
              "data-test-id": "AddTravellerDetailsComp-ExcelUpload"
            })
          })]
        }), (excelUploadError || downloadTemplateError) && /*#__PURE__*/(0,jsx_runtime.jsxs)(ExcelErrorMessage, {
          "data-test-id": "AddTravellerDetailsComp-ExcelErrorMessage",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ErrorIcon/* ErrorIcon */.P, {
            "data-test-id": "AddTravellerDetailsComp-ErrorIcon"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: excelUploadError || downloadTemplateError,
            "data-test-id": "AddTravellerDetailsComp-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ExcelPersuasion, {
          "data-test-id": "AddTravellerDetailsComp-ExcelPersuasion",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: excelPersuasionMessage,
            "data-test-id": "AddTravellerDetailsComp-FormattedText"
          })
        })]
      })]
    }), getVisibleTravellers().map((traveller, index) => {
      const {
        gender,
        isSelected
      } = traveller || {};
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: el => travellerRefMap.current[index] = el,
        "data-test-id": "AddTravellerDetailsComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TravellerDetailsV2/* default */.Z, {
          type: type,
          handleTravellerSelect: handleTravellerSelect,
          travellerIndex: index,
          travellerRef: travellerRef,
          isLoading: isLoading,
          firstErrorIndex: firstErrorIndex ?? -1,
          travellerSelected: addTrav == index,
          isSelected: isSelected,
          count: selectedCount,
          travellerNumber: `Traveller ${index + 1}`,
          isSavedTravellers: savedTravellers?.length ? true : false,
          secondaryContactData: secondaryContact?.fields,
          genderTypes: secondaryContact?.fields?.gender?.values || src.GENDER_VALUES,
          selectedGender: gender,
          handleGenderChange: item => handleGenderChange(item, index),
          handleArrowButton: () => handleArrowButton(index),
          saveFormValuesOnBlur: saveFormValuesOnBlur //   isDomesticBooking={isDomesticBooking}
          // isValidForm={isValidForm}
          ,
          isEditable: secondaryContact?.isEditable === false ? false : true //
          ,
          "data-test-id": "AddTravellerDetailsComp-TravellerDetailsV2"
        })
      }, traveller.id);
    }), !excelSectionData?.upload?.isExcelBypass && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Separator, {
        "data-test-id": "AddTravellerDetailsComp-Separator"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AddViewButton, {
        "data-test-id": "AddTravellerDetailsComp-AddViewButton",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddButtonWrap, {
          isDisabled: selectedCount === travellerCount,
          onClick: handleAddTraveller,
          "data-test-id": "AddTravellerDetailsComp-AddButtonWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
            width: "16px",
            height: "16px",
            margin: "0px 10px 0px 0px",
            src: selectedCount === travellerCount ? "https://tripmoneycmsimgak.mmtcdn.com/img/Vector_529ac663fb.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Vector_68e1489f3a.svg",
            "data-test-id": "AddTravellerDetailsComp-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: "ADD ANOTHER TRAVELLER",
            baseStyle: {
              fontWeight: "800"
            },
            "data-test-id": "AddTravellerDetailsComp-FormattedText"
          })]
        }), travellers.length > visibleTravellersCount && /*#__PURE__*/(0,jsx_runtime.jsxs)(ViewButtonWrap, {
          onClick: handleViewTraveller,
          "data-test-id": "AddTravellerDetailsComp-ViewButtonWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: showAllTravellers ? "VIEW LESS" : "VIEW ALL",
            baseStyle: {
              fontWeight: "800"
            },
            "data-test-id": "AddTravellerDetailsComp-FormattedText"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowIcon, {
            isRotated: showAllTravellers,
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
            alt: "View toggle icon",
            "data-test-id": "AddTravellerDetailsComp-ArrowIcon"
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ const AddTravellerDetailsComp_AddTravellerDetailsComp = (AddTravellerDetailsComp);

/***/ }),

/***/ 60812:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ AgentAgreementModal_AgentAgreementModal)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/constants/localData.ts
var localData = __webpack_require__(3345);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/InsuranceLanding/InsuranceLanding.style.ts
var InsuranceLanding_style = __webpack_require__(63646);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx
var CommonModalDweb = __webpack_require__(33270);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/AnchorTag.tsx
var AnchorTag = __webpack_require__(38985);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/ParaTag.tsx
var ParaTag = __webpack_require__(75641);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/SpanTag.tsx
var SpanTag = __webpack_require__(56893);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AgentAgreementModal/AgentAgreementModal.style.ts

const BannerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AgentAgreementModalstyle__BannerStyle",
  componentId: "sc-1bxaie7-0"
})(["background:", ";padding:10px;border-radius:8px;font-size:14px;font-weight:400;line-height:20px;margin-bottom:40px;"], props => props.backgroundColor);
const ConsentStyles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AgentAgreementModalstyle__ConsentStyles",
  componentId: "sc-1bxaie7-1"
})(["font-size:14px;font-weight:400;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AgentAgreementModal/AgentAgreementModal.tsx


















const AgentAgreementModal = ({
  agentAgreementData,
  showAgreementModal,
  setShowAgreementModal,
  onConstentClick
}) => {
  const [isSecond, setIsSecond] = react.useState(false);
  const [checkboxVal, setCheckboxVal] = react.useState(false);
  const analytics = (0,insurance/* getAnalytics */.I)();

  if (!showAgreementModal) {
    return null;
  } else {
    analytics?.trackLandingEvents({
      actionType: "Ins_DisclaimerPopUpShown"
    } //"click"
    );
  }

  (0,react.useEffect)(() => {
    if (showAgreementModal) {
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "Ins_DisclaimerPopUpShown"
        }
      });
    }
  }, [showAgreementModal]);
  const {
    offeredBy,
    banner,
    consent,
    cta
  } = agentAgreementData;
  const customTitleComponent = offeredBy ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
    gap: "4px",
    alignItems: "center",
    margin: "5px 0 0 0",
    "data-test-id": "AgentAgreementModal-customTitleComponent-FlexComp",
    children: [offeredBy?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
      fontWeight: "bold",
      "data-test-id": "AgentAgreementModal-customTitleComponent-SpanTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: offeredBy?.title,
        "data-test-id": "AgentAgreementModal-customTitleComponent-FormattedText"
      })
    }), offeredBy?.icons?.map((url, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      gap: "10px",
      "data-test-id": `AgentAgreementModal-customTitleComponent-FlexComp-${index}`,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
        height: "22px",
        width: "auto",
        src: url,
        loading: "eager",
        "data-test-id": "AgentAgreementModal-customTitleComponent-ImageComponent"
      }), index !== offeredBy?.icons?.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_style/* HorizontalDivider */.EL, {
        height: "22px",
        width: "1px",
        backgroundColor: "#979797",
        "data-test-id": "AgentAgreementModal-customTitleComponent-HorizontalDivider"
      })]
    }, index))]
  }) : null;

  function formatTextWithButtons(text) {
    const regex = /\{([^{}]+)\}(.*?)\{\/\1\}/g;
    const parts = [];
    let lastIndex = 0;
    text.replace(regex, (match, tag, content, offset) => {
      if (lastIndex < offset) {
        parts.push(text.slice(lastIndex, offset));
      }

      parts.push( /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        style: {
          color: "#008CFF"
        },
        onClick: () => {
          analytics?.trackLandingEvents({
            actionType: "Ins_DisclaimerClicked"
          } //"click"
          );
          (0,XDMAnalytics.trackEvent)({
            event_detail: {
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: "Ins_DisclaimerClicked"
            }
          });
          setIsSecond(true);
        },
        "data-test-id": "AgentAgreementModal",
        children: content
      }));
      lastIndex = offset + match.length;
      return "";
    });

    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts;
  }

  const customTitleComponentBack = /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorTag/* default */.Z, {
    handleClick: () => {
      analytics?.trackLandingEvents({
        actionType: "Ins_DisclaimerBackClicked"
      } //"click"
      );
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "Ins_DisclaimerBackClicked"
        }
      });
      setIsSecond(false);
    },
    fontSize: "xs",
    fontWeight: "700",
    color: "black",
    margin: "5px 0 0 0",
    "data-test-id": "AgentAgreementModal-customTitleComponentBack-AnchorTag",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
      value: "< Back",
      "data-test-id": "AgentAgreementModal-customTitleComponentBack-FormattedText"
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!isSecond && /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb/* default */.Z, {
      handleClick: () => {
        analytics?.trackLandingEvents({
          actionType: "Ins_DisclaimerClosed"
        } //"click"
        );
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "Ins_DisclaimerClosed"
          }
        });
        setShowAgreementModal(false);
      },
      customTitleComponent: customTitleComponent,
      customWidth: "640px",
      "data-test-id": "AgentAgreementModal-CommonModalDweb",
      children: [banner && banner.description && /*#__PURE__*/(0,jsx_runtime.jsx)(BannerStyle, {
        backgroundColor: banner?.backgroundColor,
        "data-test-id": "AgentAgreementModal-BannerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: banner?.description,
          "data-test-id": "AgentAgreementModal-FormattedText"
        })
      }), consent && /*#__PURE__*/(0,jsx_runtime.jsx)(ConsentStyles, {
        "data-test-id": "AgentAgreementModal-ConsentStyles",
        children: consent.text && consent.text.map((text, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(components.CheckButton, {
          inputId: "confirmTnC",
          handleChange: () => {
            analytics?.trackLandingEvents({
              actionType: `${checkboxVal ? `Ins_DisclaimerCheckBoxUnchecked` : `Ins_DisclaimerCheckBoxChecked`}`
            } //"click"
            );
            (0,XDMAnalytics.trackEvent)({
              event_detail: {
                event_type: "action",
                event_name: "component_cta-clicked",
                event_value: `${checkboxVal ? `Ins_DisclaimerCheckBoxUnchecked` : `Ins_DisclaimerCheckBoxChecked`}`
              }
            });
            setCheckboxVal(!checkboxVal);
          },
          margin: "0 0 24px 0 ",
          isChecked: checkboxVal,
          "data-test-id": "AgentAgreementModal-CheckButton",
          children: formatTextWithButtons(text)
        }))
      }), cta && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [cta.text && /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
          customTitle: cta.text,
          disableState: !checkboxVal,
          customWidth: "100%",
          onClick: onConstentClick,
          "data-test-id": "AgentAgreementModal-LandingButton"
        }), cta.description && /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTag/* default */.Z, {
          color: "#4a4a4a",
          margin: "12px 0 0 0",
          "data-test-id": "AgentAgreementModal-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: cta.description,
            "data-test-id": "AgentAgreementModal-FormattedText"
          })
        })]
      })]
    }), isSecond && /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb/* default */.Z, {
      handleClick: () => {
        analytics?.trackLandingEvents({
          actionType: "Ins_DisclaimerClosed"
        } //"click"
        );
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "Ins_DisclaimerClosed"
          }
        });
        setShowAgreementModal(false);
        setIsSecond(false);
      },
      customTitleComponent: customTitleComponentBack,
      customWidth: "640px",
      "data-test-id": "AgentAgreementModal-CommonModalDweb",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
        margin: "0 0 16px 0",
        "data-test-id": "AgentAgreementModal-H5Tag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: localData/* LOCAL_TERMS_AND_CONDITIONS.heading */.l5.heading,
          "data-test-id": "AgentAgreementModal-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTag/* default */.Z, {
        margin: "0 0 16px 0",
        "data-test-id": "AgentAgreementModal-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: localData/* LOCAL_TERMS_AND_CONDITIONS.body */.l5.body
          }
        })
      })]
    })]
  });
};

/* harmony default export */ const AgentAgreementModal_AgentAgreementModal = (AgentAgreementModal);

/***/ }),

/***/ 13255:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ BackDropComp_BackDropComp)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BackDropComp/BackDropComp.style.ts

const BackDropCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BackDropCompstyle__BackDropCompStyle",
  componentId: "f3s9gn-0"
})(["position:fixed;top:0;left:0;background-color:rgba(0,0,0,0.5);z-index:46;width:100%;height:", ";"], p => p.height ? `${p.height}px` : "100vh");
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BackDropComp/BackDropComp.tsx




const BackDropComp = ({
  onClose
}) => {
  const {
    0: height,
    1: setHeight
  } = (0,react.useState)(undefined);
  (0,react.useEffect)(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    if (true) {
      setHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BackDropCompStyle, {
    onClick: onClose,
    height: height,
    "data-test-id": "BackDropComp-BackDropCompStyle"
  });
};

/* harmony default export */ const BackDropComp_BackDropComp = (BackDropComp);

/***/ }),

/***/ 73818:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ BannerCarousel_BannerCarousel)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BannerCarousel/BannerCarousel.style.ts

const CarouselContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BannerCarouselstyle__CarouselContainer",
  componentId: "sc-927jlq-0"
})(["position:relative;width:1200px;overflow:hidden;background:transparent;padding-bottom:10px;margin:0 auto;"]);
const BannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BannerCarouselstyle__BannerWrapper",
  componentId: "sc-927jlq-1"
})(["display:flex;transition:transform 0.5s ease-in-out;transform:translateX(-", "%);will-change:transform;width:1200px;height:180px;border-radius:8px;"], props => props.currentIndex * 100);
const BannerSlide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BannerCarouselstyle__BannerSlide",
  componentId: "sc-927jlq-2"
})(["min-width:100%;cursor:pointer;display:flex;align-items:center;justify-content:center;"]);
const DotsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BannerCarouselstyle__DotsContainer",
  componentId: "sc-927jlq-3"
})(["display:flex;justify-content:center;bottom:16px;gap:8px;"]);
const Dot = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "BannerCarouselstyle__Dot",
  componentId: "sc-927jlq-4"
})(["width:", ";height:8px;border-radius:4px;border:none;background-color:", ";cursor:pointer;transition:all 0.3s ease;padding:0;&:hover{background-color:", ";}&:focus{outline:2px solid #008cff;outline-offset:2px;}"], props => props.active ? "24px" : "8px", props => props.active ? "#008CFF" : "rgba(255, 255, 255, 0.5)", props => props.active ? "#008CFF" : "rgba(255, 255, 255, 0.8)");
const BannerContent = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "BannerCarouselstyle__BannerContent",
  componentId: "sc-927jlq-5"
})(["object-fit:cover;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BannerCarousel/BannerCarousel.tsx






const defaultBanners = [{
  imageUrl: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_1321318094_0b70f9084f.png",
  navigationUrl: "https://www.google.com"
}, {
  imageUrl: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_1321318094_0b70f9084f.png",
  navigationUrl: "https://www.google.com"
}];

const BannerCarousel = ({
  banners = defaultBanners,
  autoScrollInterval = 3000
}) => {
  const {
    0: currentIndex,
    1: setCurrentIndex
  } = (0,react.useState)(0);
  const {
    0: isHovered,
    1: setIsHovered
  } = (0,react.useState)(false);
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "marketing_banner_carousel_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: bannerCarouselRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  const goToSlide = (0,react.useCallback)(index => {
    setCurrentIndex(index);
  }, []);
  const goToNext = (0,react.useCallback)(() => {
    setCurrentIndex(prevIndex => prevIndex === banners.length - 1 ? 0 : prevIndex + 1);
  }, [banners.length]);
  const goToPrevious = (0,react.useCallback)(() => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? banners.length - 1 : prevIndex - 1);
  }, [banners.length]); // Auto-scroll functionality

  (0,react.useEffect)(() => {
    if (isHovered || banners.length <= 1) return;
    const intervalId = setInterval(() => {
      goToNext();
    }, autoScrollInterval);
    return () => clearInterval(intervalId);
  }, [isHovered, autoScrollInterval, goToNext, banners.length]); // Touch/swipe functionality

  const {
    0: touchStart,
    1: setTouchStart
  } = (0,react.useState)(null);
  const {
    0: touchEnd,
    1: setTouchEnd
  } = (0,react.useState)(null);
  const minSwipeDistance = 50;

  const onTouchStart = e => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      goToNext();
    } else if (isRightSwipe) {
      goToPrevious();
    }
  };

  const handleBannerClick = navigationUrl => {
    if (navigationUrl) {
      window.open(navigationUrl, "_blank");
    }
  };

  if (!banners || banners.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CarouselContainer, {
    ref: bannerCarouselRef,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd,
    "data-test-id": "BannerCarousel-CarouselContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BannerWrapper, {
      currentIndex: currentIndex,
      "data-test-id": "BannerCarousel-BannerWrapper",
      children: banners.map((banner, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(BannerSlide, {
        onClick: () => handleBannerClick(banner.navigationUrl),
        "data-test-id": `BannerCarousel-BannerSlide-${index}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BannerContent, {
          src: banner.imageUrl,
          "data-test-id": "BannerCarousel-BannerContent"
        })
      }, index))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DotsContainer, {
      "data-test-id": "BannerCarousel-DotsContainer",
      children: banners.map((_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Dot, {
        active: index === currentIndex,
        onClick: () => goToSlide(index),
        "aria-label": `Go to slide ${index + 1}`,
        "data-test-id": `BannerCarousel-Dot-${index}`
      }, index))
    })]
  });
};

/* harmony default export */ const BannerCarousel_BannerCarousel = (BannerCarousel);

/***/ }),

/***/ 16724:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BottomBar": () => (/* binding */ BottomBar),
  "default": () => (/* binding */ BottomBar_BottomBar)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SocialLogos/SocialLogos.tsx + 1 modules
var SocialLogos = __webpack_require__(15364);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BottomBar/BottomBar.styles.tsx

const FooterBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BottomBarstyles__FooterBottom",
  componentId: "m3vn5y-0"
})(["background:#000;padding:50px 0 60px;"]);
const LandingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BottomBarstyles__LandingContainer",
  componentId: "m3vn5y-1"
})(["width:1200px;margin:0 auto;display:flex;color:#ffffff;align-items:center;"]);
const CopyrightContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BottomBarstyles__CopyrightContainer",
  componentId: "m3vn5y-2"
})(["margin-left:auto;display:flex;flex-direction:column;text-align:right;justify-content:flex-end;"]);
const CopyrightText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "BottomBarstyles__CopyrightText",
  componentId: "m3vn5y-3"
})(["margin-bottom:5px;font-weight:700;font-size:calc(var(--font-scale,1) * 16px);line-height:16px;font-family:var(--font-family);color:#ffffff;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BottomBar/BottomBar.tsx




const BottomBar = ({
  data
}) => {
  const IN_ORG_NAME = data?.inOrgName || "MAKEMYTRIP PVT. LTD.";
  const ORG_COPYRIGHT_YEAR = data?.orgCopyrightYear || "© 2025";
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FooterBottom, {
    "data-test-id": "BottomBar-FooterBottom",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingContainer, {
      "data-test-id": "BottomBar-LandingContainer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SocialLogos/* default */.Z, {
        "data-test-id": "BottomBar-SocialLogos"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CopyrightContainer, {
        "data-test-id": "BottomBar-CopyrightContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CopyrightText, {
          "data-test-id": "BottomBar-CopyrightText",
          children: `${ORG_COPYRIGHT_YEAR} ${IN_ORG_NAME}`
        })
      })]
    })
  });
};
/* harmony default export */ const BottomBar_BottomBar = (BottomBar);

/***/ }),

/***/ 17852:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ BreadcrumbComponent_BreadcrumbComponent)
});

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BreadcrumbComponent/BreadcrumbComponent.style.ts


const BreadcrumbNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "BreadcrumbComponentstyle__BreadcrumbNav",
  componentId: "rx4kw-0"
})(["width:100%;margin:0 auto;"]);
const BreadcrumbContainer = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
  displayName: "BreadcrumbComponentstyle__BreadcrumbContainer",
  componentId: "rx4kw-1"
})(["display:flex;align-items:center;list-style:none;padding:0;margin:0;background:transparent;@media ", "{padding:0;}"], src.deviceType.mobile);
const BreadcrumbItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "BreadcrumbComponentstyle__BreadcrumbItem",
  componentId: "rx4kw-2"
})(["color:", ";font-size:14px;font-weight:", ";line-height:1.4;@media ", "{font-size:12px;}"], props => props.isActive ? "#ffffff" : "#b3c6d9", props => props.isActive ? "500" : "400", src.deviceType.mobile);
const BreadcrumbLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "BreadcrumbComponentstyle__BreadcrumbLink",
  componentId: "rx4kw-3"
})(["color:#b3c6d9;text-decoration:none;cursor:pointer;transition:color 0.2s ease;&:hover{color:#ffffff;text-decoration:underline;}&:visited{color:#b3c6d9;}&:focus{outline:2px solid #ffffff;outline-offset:2px;border-radius:2px;}"]);
const BreadcrumbSeparator = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "BreadcrumbComponentstyle__BreadcrumbSeparator",
  componentId: "rx4kw-4"
})(["color:#b3c6d9;margin:0 8px;font-size:14px;user-select:none;font-weight:400;@media ", "{margin:0 6px;font-size:12px;}"], src.deviceType.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BreadcrumbComponent/BreadcrumbComponent.tsx





// Default configuration for insurance pages
const defaultBreadcrumbConfig = {
  // For www.makemytrip.com
  "/insurance": [{
    label: "Home",
    url: "/insurance"
  }],
  "/insurance/listing": [{
    label: "Home",
    url: "/insurance"
  }, {
    label: "Travel Insurance",
    url: "/insurance/listing"
  }],
  "/insurance/traveller-details": [{
    label: "Home",
    url: "/insurance"
  }, {
    label: "Traveler Details",
    url: "/insurance/traveller-details"
  }],
  // For insurance.makemytrip.com (root level paths)
  "/": [{
    label: "Home",
    url: "/insurance"
  }],
  "/listing": [{
    label: "Home",
    url: "/insurance"
  }, {
    label: "Travel Insurance",
    url: "/insurance/listing"
  }],
  "/traveller-details": [{
    label: "Home",
    url: "/insurance"
  }, {
    label: "Traveler Details",
    url: "/insurance/traveller-details"
  }]
};

const BreadcrumbComponent = ({
  className,
  hostname: propHostname,
  customConfig
}) => {
  const router = (0,next_router.useRouter)(); // Get current path and hostname

  const currentPath = router.asPath; // Remove query parameters to get clean pathname

  const pathname = currentPath.split("?")[0];
  const hostname = propHostname || ( true ? window.location.hostname : 0);

  const generateBreadcrumbs = () => {
    const config = customConfig || defaultBreadcrumbConfig; // Find matching configuration for current path

    let breadcrumbItems = []; // Check for exact match first

    if (config[pathname]) {
      breadcrumbItems = config[pathname];
    } else {
      // Check for partial matches (for dynamic routes)
      for (const configPath in config) {
        if (pathname.startsWith(configPath) && configPath !== "/") {
          breadcrumbItems = config[configPath];
          break;
        }
      }
    } // If no match found, create default breadcrumb based on hostname


    if (breadcrumbItems.length === 0) {
      const isInsuranceSubdomain = hostname.includes("insurance.makemytrip.com");
      breadcrumbItems = [{
        label: "Home",
        url: isInsuranceSubdomain ? "/" : "/insurance"
      }];
    } // Transform to internal breadcrumb format


    return breadcrumbItems.map((item, index) => {
      const isCurrentPage = index === breadcrumbItems.length - 1;
      return {
        label: item.label,
        href: isCurrentPage ? null : `https://${hostname}${item.url}`,
        isActive: isCurrentPage
      };
    });
  };

  const breadcrumbs = generateBreadcrumbs(); // Don't show breadcrumb if only home exists or if we're on home page

  const isInsuranceSubdomain = hostname.includes("insurance.makemytrip.com");
  const isHomePage = isInsuranceSubdomain ? pathname === "/" : pathname === "/insurance";

  if (breadcrumbs.length <= 1 && isHomePage) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbNav, {
    "aria-label": "Breadcrumb",
    className: className,
    "data-test-id": "BreadcrumbComponent-BreadcrumbNav",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbContainer, {
      "data-test-id": "BreadcrumbComponent-BreadcrumbContainer",
      children: breadcrumbs.map((breadcrumb, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbItem, {
          isActive: breadcrumb.isActive,
          "aria-current": breadcrumb.isActive ? "page" : undefined,
          "data-test-id": "BreadcrumbComponent-BreadcrumbItem",
          children: breadcrumb.href ? /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbLink, {
            href: breadcrumb.href,
            onClick: e => {
              e.preventDefault();

              if (breadcrumb.href) {
                window.location.href = breadcrumb.href;
              }
            },
            "data-test-id": "BreadcrumbComponent-BreadcrumbLink",
            children: breadcrumb.label
          }) : breadcrumb.label
        }), index < breadcrumbs.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbSeparator, {
          "aria-hidden": "true",
          "data-test-id": "BreadcrumbComponent-BreadcrumbSeparator",
          children: ">"
        })]
      }, index))
    })
  });
};

/* harmony default export */ const BreadcrumbComponent_BreadcrumbComponent = (BreadcrumbComponent);

/***/ }),

/***/ 98988:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ BulletListItemStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);


const BulletListItemStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "BulletListItemstyle__BulletListItemStyle",
  componentId: "unxr0c-0"
})(["margin-bottom:20px;padding-left:20px;position:relative;font-size:18px;line-height:22px;color:", ";&:last-child{margin-bottom:0px;}&:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText */ .rS.greyText, props => props.bulletColor);

/***/ }),

/***/ 50996:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _BulletListItem_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98988);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);




const BulletListItem = ({
  children,
  bulletColor = _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.darkYellowText */ .rS.darkYellowText
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_BulletListItem_style__WEBPACK_IMPORTED_MODULE_0__/* .BulletListItemStyle */ .I, {
    bulletColor: bulletColor,
    "data-test-id": "BulletListItem-BulletListItemStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BulletListItem);

/***/ }),

/***/ 56869:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ CalendarPersuasionModal_CalendarPersuasionModal)
});

// UNUSED EXPORTS: CalendarPersuasionModal

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InfoModal/InfoModal.style.ts
var InfoModal_style = __webpack_require__(76124);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.tsx
var LandingButton = __webpack_require__(99660);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ModalWrapper/ModalWrapper.tsx + 1 modules
var ModalWrapper = __webpack_require__(38949);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CalendarPersuasionModal/CalendarPersuasionModal.style.ts

const ModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarPersuasionModalstyle__ModalHeader",
  componentId: "sc-145o1ki-0"
})(["background:#ffffff;padding:30px 30px 0;text-align:left;position:relative;"]);
const IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarPersuasionModalstyle__IconContainer",
  componentId: "sc-145o1ki-1"
})(["position:absolute;top:20px;right:30px;width:60px;height:60px;img{width:100%;height:100%;object-fit:contain;}"]);
const MainHeading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "CalendarPersuasionModalstyle__MainHeading",
  componentId: "sc-145o1ki-2"
})(["font-size:28px;font-weight:700;color:#000000;margin:0;line-height:1.3;max-width:75%;"]);
const ModalBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarPersuasionModalstyle__ModalBody",
  componentId: "sc-145o1ki-3"
})(["padding:20px 30px 0;"]);
const SectionLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "CalendarPersuasionModalstyle__SectionLabel",
  componentId: "sc-145o1ki-4"
})(["font-size:14px;font-weight:400;color:#4a4a4a;"]);
const SectionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarPersuasionModalstyle__SectionContent",
  componentId: "sc-145o1ki-5"
})(["font-size:16px;line-height:1.5;color:#000000;"]);
const Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "CalendarPersuasionModalstyle__Description",
  componentId: "sc-145o1ki-6"
})(["font-size:16px;font-weight:400;color:#4a4a4a;line-height:1.6;margin:0 0 20px 0;"]);
const PersuasionBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarPersuasionModalstyle__PersuasionBox",
  componentId: "sc-145o1ki-7"
})(["background:#e8f4f8;border-radius:8px;padding:16px;font-size:14px;line-height:1.5;color:#006064;font-weight:400;span{display:inline;}"]);
const ListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarPersuasionModalstyle__ListContainer",
  componentId: "sc-145o1ki-8"
})(["padding:16px 30px 30px;"]);
const BulletList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "CalendarPersuasionModalstyle__BulletList",
  componentId: "sc-145o1ki-9"
})(["list-style:none;margin:0 0 30px 0;padding:0;display:flex;flex-direction:column;gap:8px;"]);
const BulletItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "CalendarPersuasionModalstyle__BulletItem",
  componentId: "sc-145o1ki-10"
})(["display:flex;align-items:flex-start;gap:12px;"]);
const BulletIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarPersuasionModalstyle__BulletIcon",
  componentId: "sc-145o1ki-11"
})(["width:6px;height:6px;border-radius:50%;background-color:#000000;flex-shrink:0;margin-top:8px;"]);
const BulletText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarPersuasionModalstyle__BulletText",
  componentId: "sc-145o1ki-12"
})(["font-size:16px;line-height:1.5;color:#000000;flex:1;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CalendarPersuasionModal/CalendarPersuasionModal.tsx










const CalendarPersuasionModal = ({
  data,
  isOpen,
  onClose,
  onPrimaryCTAClick
}) => {
  if (!data) return null;
  const analytics = (0,insurance/* getAnalytics */.I)();
  (0,react.useEffect)(() => {
    analytics?.trackCommonLandingEvents({
      actionType: "calendarPersuasionModal_seen"
    });
  }, []);
  const primaryCtaText = typeof data.modal.primaryCtaText?.text === "object" && !Array.isArray(data.modal.primaryCtaText?.text) ? data.modal.primaryCtaText?.text?.value : "Try ANNUAL PLAN";

  const handlePrimaryClick = () => {
    if (onPrimaryCTAClick) {
      onPrimaryCTAClick();
    } else {
      onClose();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalWrapper/* ModalWrapper */.A, {
    isOpen: isOpen,
    onClose: onClose,
    "data-test-id": "CalendarPersuasionModal-ModalWrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ModalHeader, {
      "data-test-id": "CalendarPersuasionModal-ModalHeader",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MainHeading, {
        "data-test-id": "CalendarPersuasionModal-MainHeading",
        children: data.modal.heading
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconContainer, {
        "data-test-id": "CalendarPersuasionModal-IconContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
          src: data.modal.icon,
          width: "100%",
          height: "100%",
          alt: "Annual Plan",
          "data-test-id": "CalendarPersuasionModal-ImageComponent"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalBody, {
      "data-test-id": "CalendarPersuasionModal-ModalBody",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        "data-test-id": "CalendarPersuasionModal-SectionLabel",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: data.modal.header,
          "data-test-id": "CalendarPersuasionModal-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionContent, {
        "data-test-id": "CalendarPersuasionModal-SectionContent",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: data.modal.subHeader,
          "data-test-id": "CalendarPersuasionModal-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        "data-test-id": "CalendarPersuasionModal-Description",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: data.modal.description,
          "data-test-id": "CalendarPersuasionModal-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersuasionBox, {
        "data-test-id": "CalendarPersuasionModal-PersuasionBox",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: data.modal.persuasion,
          "data-test-id": "CalendarPersuasionModal-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListContainer, {
        "data-test-id": "CalendarPersuasionModal-ListContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BulletList, {
          "data-test-id": "CalendarPersuasionModal-BulletList",
          children: data?.modal?.list?.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(InfoModal_style/* BulletItem */.vo, {
            "data-test-id": `CalendarPersuasionModal-BulletItem-${index}`,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BulletIcon, {
              "data-test-id": "CalendarPersuasionModal-BulletIcon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(BulletText, {
              "data-test-id": "CalendarPersuasionModal-BulletText",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: item.title,
                "data-test-id": "CalendarPersuasionModal-FormattedText"
              })
            })]
          }, index))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton/* default */.Z, {
          customTitle: primaryCtaText,
          onClick: () => {
            analytics?.trackCommonLandingEvents({
              actionType: "calendar_annual_multi_trip_primary_cta_clicked"
            });
            handlePrimaryClick();
          },
          customWidth: "100%",
          "data-test-id": "CalendarPersuasionModal-LandingButton"
        })]
      })]
    })]
  });
};
/* harmony default export */ const CalendarPersuasionModal_CalendarPersuasionModal = (CalendarPersuasionModal);

/***/ }),

/***/ 21764:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ CarouselPersuasion_CarouselPersuasion)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/DropOffModal/DropOffModal.tsx + 1 modules
var DropOffModal = __webpack_require__(81291);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CarouselPersuasion/CarouselPersuasion.style.ts


const fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(["from{opacity:0;}to{opacity:1;}"]);
const CarouselPersuasionStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CarouselPersuasionstyle__CarouselPersuasionStyle",
  componentId: "kxggud-0"
})(["display:flex;flex-direction:row;gap:10px;width:328px;"]);
const CarouselItemStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CarouselPersuasionstyle__CarouselItemStyle",
  componentId: "kxggud-1"
})(["display:flex;flex-direction:row;align-items:center;gap:10px;width:100%;font-size:16px;font-weight:700;color:", ";", " opacity:", ";transition:opacity 0.1s ease-out;"], Global/* theme.whiteText */.rS.whiteText, ({
  isAnimating
}) => isAnimating && (0,styled_components_browser_esm/* css */.iv)(["animation:", " 0.1s ease-in;"], fadeIn), ({
  isAnimating
}) => isAnimating ? 1 : 0);
const ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CarouselPersuasionstyle__ImageContainer",
  componentId: "kxggud-2"
})(["cursor:pointer;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CarouselPersuasion/CarouselPersuasion.tsx











const CarouselPersuasion = ({
  carouselPersuasionData
}) => {
  const {
    0: currentIndex,
    1: setCurrentIndex
  } = (0,react.useState)(0);
  const {
    0: isAnimating,
    1: setIsAnimating
  } = (0,react.useState)(true);
  const {
    0: showDropOffModal,
    1: setShowDropOffModal
  } = (0,react.useState)(false);
  const {
    0: modalData,
    1: setModalData
  } = (0,react.useState)(null);
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "value_prop_animation_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: carouselPersuasionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  (0,react.useEffect)(() => {
    // Only rotate if there's more than 1 item
    if (carouselPersuasionData.length <= 1) {
      return;
    }

    const interval = setInterval(() => {
      setIsAnimating(false);
      setTimeout(() => {
        setCurrentIndex(prevIndex => (prevIndex + 1) % carouselPersuasionData.length);
        setIsAnimating(true);
      }, 100); // Short delay for fade out before changing content
    }, 3000);
    return () => clearInterval(interval);
  }, [carouselPersuasionData.length]);

  const handleRightIconClick = (item, index) => {
    analytics?.trackCommonLandingEvents({
      actionType: `value_prop_${index}_animation_clicked`
    });

    if (item.url) {
      window.open(item.url, "_blank");
    }

    if (item.dropOffBottomSheet) {
      setModalData(item.dropOffBottomSheet);
      setShowDropOffModal(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CarouselPersuasionStyle, {
      ref: carouselPersuasionRef,
      "data-test-id": "CarouselPersuasion-CarouselPersuasionStyle",
      children: carouselPersuasionData.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(CarouselItemStyle, {
        isAnimating: isAnimating && index === currentIndex,
        style: {
          display: index === currentIndex ? "flex" : "none"
        },
        "data-test-id": `CarouselPersuasion-CarouselItemStyle-${index}`,
        children: [item?.leftIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
          src: item.leftIcon,
          width: "20px",
          height: "20px",
          alt: "leftIcon",
          loading: "eager",
          "data-test-id": "CarouselPersuasion-ImageComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: item?.title,
          "data-test-id": "CarouselPersuasion-FormattedText"
        }), item?.rightIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageContainer, {
          onClick: () => handleRightIconClick(item, index),
          "data-test-id": "CarouselPersuasion-ImageContainer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
            src: item.rightIcon,
            width: "16px",
            height: "16px",
            alt: "rightIcon",
            loading: "eager",
            "data-test-id": "CarouselPersuasion-ImageComponent"
          })
        })]
      }, index))
    }), showDropOffModal && /*#__PURE__*/(0,jsx_runtime.jsx)(DropOffModal/* default */.Z, {
      isOpen: showDropOffModal,
      onClose: () => setShowDropOffModal(false),
      data: modalData,
      onCTAClick: () => setShowDropOffModal(false),
      "data-test-id": "CarouselPersuasion-DropOffModal"
    })]
  });
};

/* harmony default export */ const CarouselPersuasion_CarouselPersuasion = (CarouselPersuasion);

/***/ }),

/***/ 73232:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Chatbot_Chatbot)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 1 modules
var utility_src = __webpack_require__(97427);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Chatbot/Chatbot.style.ts


const getBottomPosition = props => {
  if (props.device === "lg") {
    if (props.pageName === "LISTING") {
      return "112px";
    }

    return "25px";
  } else if (props.device === "sm") {
    return "0";
  } else {
    return "10px";
  }
};

const myraAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{right:calc(50% - 30px);}100%{right:90px;}"]);
const ChatbotIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Chatbotstyle__ChatbotIcon",
  componentId: "sc-1me21yy-0"
})(["position:fixed;bottom:", ";right:40px;z-index:1000;width:60px;height:60px;cursor:pointer;", ""], props => `${props.chatbotBottomMargin}px`, props => props.showAnimation && (0,styled_components_browser_esm/* css */.iv)(["animation:", " 3s ease-out;"], myraAnimation));
const ChatbotIframe = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "Chatbotstyle__ChatbotIframe",
  componentId: "sc-1me21yy-1"
})(["height:", ";width:", ";bottom:", ";right:", ";position:fixed;z-index:1001;box-shadow:none;"], props => props.device == "lg" ? "554px" : "85vh", props => props.device == "lg" ? "360px" : "100%", props => getBottomPosition(props), props => props.device == "lg" ? "20px" : "0");
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Chatbot/ChatbotPersuasionText.style.ts

const RightPersuasionTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChatbotPersuasionTextstyle__RightPersuasionTextWrapper",
  componentId: "e6zrc4-0"
})(["display:flex;flex-direction:column;font-size:14px;font-weight:400;height:34px;justify-content:center;line-height:21px;padding:5px 0 5px 6px;width:150px;"]);
const PersuasionText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ChatbotPersuasionTextstyle__PersuasionText",
  componentId: "e6zrc4-1"
})(["display:flex;max-height:100%;overflow:hidden;color:#262626;cursor:pointer;font-size:14px;font-weight:400;height:18px;line-height:21px;"]);
const PersuasionTextSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ChatbotPersuasionTextstyle__PersuasionTextSpan",
  componentId: "e6zrc4-2"
})(["line-height:18px;color:#000000;font-weight:600;font-size:16px;cursor pointer;"]);
const MyraContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChatbotPersuasionTextstyle__MyraContainer",
  componentId: "e6zrc4-3"
})(["position:fixed;bottom:40px;right:200px;z-index:1000;width:60px;height:60px;cursor:pointer;"]);
const MyraIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChatbotPersuasionTextstyle__MyraIconContainer",
  componentId: "e6zrc4-4"
})(["border:4px solid rgb(200,109,215);background-color:rgb(255,255,255);border-radius:50px;width:218px;overflow:hidden;align-items:center;display:flex;height:68px;"]);
const Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChatbotPersuasionTextstyle__Icon",
  componentId: "e6zrc4-5"
})(["padding-top:5px;background-color:#f5f5f5;border-radius:50%;background-repeat:no-repeat;background-size:contain;display:block;box-shadow:0 0 10px 0 rgba(0,0,0,0.1);"]);
const MyraBorder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChatbotPersuasionTextstyle__MyraBorder",
  componentId: "e6zrc4-6"
})(["width:60px;display:flex;align-items:center;justify-content:center;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Chatbot/ChatbotPersuasionText.tsx






const ChatbotPersuasionText = ({
  src,
  onClick
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MyraContainer, {
    onClick: onClick,
    device: device,
    "data-test-id": "ChatbotPersuasionText-MyraContainer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(MyraIconContainer, {
      "data-test-id": "ChatbotPersuasionText-MyraIconContainer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MyraBorder, {
        "data-test-id": "ChatbotPersuasionText-MyraBorder",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
          "data-test-id": "ChatbotPersuasionText-Icon",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: src,
            alt: "Myra Animation"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RightPersuasionTextWrapper, {
        "data-test-id": "ChatbotPersuasionText-RightPersuasionTextWrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PersuasionText, {
          "data-test-id": "ChatbotPersuasionText-PersuasionText",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PersuasionTextSpan, {
            "data-test-id": "ChatbotPersuasionText-PersuasionTextSpan",
            children: "Hey I am Myra"
          })
        })
      })]
    })
  });
};

/* harmony default export */ const Chatbot_ChatbotPersuasionText = (ChatbotPersuasionText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Chatbot/Chatbot.tsx











const Chatbot = ({
  myraUrl,
  pageName,
  chatbotBottomMargin = 40
}) => {
  const {
    0: showChatBot,
    1: setShowChatBot
  } = (0,react.useState)(false);
  const {
    0: showAnimation,
    1: setShowAnimation
  } = (0,react.useState)(false);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const analytics = (0,insurance/* getAnalytics */.I)();
  const ref = (0,react.useRef)(null);
  const imageUrl = "https://imgak.mmtcdn.com/flights/assets/media/mobile/listing/3X/myra_new_gif.webp?v=2";
  const {
    type
  } = (0,src/* usePlanType */.U)();

  const handleShowAnimation = () => {
    let showAnimationTime = (0,utility_src/* getSessionStorageItem */.St)("showAnimationTime") || "";
    const currentTime = new Date().getTime();

    if (!showAnimationTime || currentTime - parseInt(showAnimationTime) >= 3600000) {
      showAnimationTime = currentTime.toString();
      (0,utility_src/* setSessionStorageItem */.D9)("showAnimationTime", showAnimationTime);
      return true;
    }

    return false;
  };

  (0,react.useEffect)(() => {
    if (pageName && pageName === "LANDING" && device === "lg") {
      const sessionAnimation = handleShowAnimation();
      setShowAnimation(sessionAnimation);
      const timer = setTimeout(() => {
        setShowAnimation(false);
      }, 3000);
      return () => clearTimeout(timer);
    }

    return;
  }, [pageName, device]);

  const getMyraAppLinkOrigin = () => {
    try {
      return new URL(myraUrl).origin;
    } catch (e) {
      return "Error getting myra url origin";
    }
  };

  const handleMessage = event => {
    // Ensure the message comes from the correct origin
    if (event.origin !== getMyraAppLinkOrigin()) {
      return;
    }

    const {
      type
    } = event.data || {};

    if (type === "CHAT_BOT__BRIDGE__MINIMIZE_VIEW" || type === "CHAT_BOT__BRIDGE__CLOSE_VIEW") {
      setShowChatBot(false);
    }
  };

  const handleClickOutside = event => {
    if (ref?.current && !ref?.current?.contains(event.target)) {
      setShowChatBot(false);
    }
  };

  const addChatbotAnalytics = eventName => {
    if (pageName) {
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: eventName
        }
      });

      switch (pageName) {
        case "LANDING":
          analytics?.trackLandingEvents({
            actionType: eventName
          }, "pageView", type);
          break;

        case "LISTING":
          analytics?.trackListingEvents({
            actionType: eventName
          }, "pageView", type);
          break;

        case "ADD_TRAVELLERS":
          analytics?.trackTravDetailsEvents({
            actionType: eventName
          }, "pageView", type);
          break;

        default:
          break;
      }
    }
  };

  (0,react.useEffect)(() => {
    // Attach event listener to listen for messages from the iframe
    window.addEventListener("message", handleMessage);
    addChatbotAnalytics("chatbot_shown"); // Cleanup on component unmount

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  (0,react.useEffect)(() => {
    if (device === "sm") {
      if (showChatBot) {
        document.body.style.overflow = "hidden";
      }

      if (!showChatBot) {
        document.body.style.overflow = "auto";
      }
    }

    if (showChatBot) {
      document.addEventListener("click", handleClickOutside, false);
    } else {
      document.removeEventListener("click", handleClickOutside, false);
    }
  }, [showChatBot]);

  const chatbotClickHandler = () => {
    setShowChatBot(true);
    addChatbotAnalytics("chatbot_clicked");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    "data-test-id": "Chatbot",
    children: [!showAnimation && pageName === "LANDING" && device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(Chatbot_ChatbotPersuasionText, {
      src: imageUrl,
      onClick: chatbotClickHandler,
      "data-test-id": "Chatbot-ChatbotPersuasionText"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ChatbotIcon, {
      src: imageUrl,
      alt: "Myra Animation",
      pageName: pageName,
      onClick: chatbotClickHandler,
      showAnimation: showAnimation,
      chatbotBottomMargin: chatbotBottomMargin,
      "data-test-id": "Chatbot-ChatbotIcon"
    }), showChatBot && /*#__PURE__*/(0,jsx_runtime.jsx)(ChatbotIframe, {
      device: device,
      src: myraUrl,
      title: "myraChatBot",
      pageName: pageName,
      "data-test-id": "Chatbot-ChatbotIframe"
    })]
  });
};

/* harmony default export */ const Chatbot_Chatbot = (Chatbot);

/***/ })

}]);